import React, { useCallback, useEffect, useMemo, useState } from "react";
// import OvertimeSettings from "../Attendance/OvertimeSettings";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { AgGridReact } from "ag-grid-react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";


import { Form, InputGroup, Row, Col, Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { MultiSelect } from "react-multi-select-component";
// Icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdOutlineAssignmentTurnedIn, MdDeleteOutline } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoIosArrowRoundBack } from "react-icons/io";
import { MdFingerprint } from "react-icons/md";
import { FaRegSquarePlus } from "react-icons/fa6";
import { FiMinusSquare } from "react-icons/fi";
import Switch from "@mui/material/Switch";
// Reusable Component
import ButtonCom from "../../components/button/button";
import CustomButton from "../../components/button/button";

import CustomPagination from "../../components/CustomPagination";
import { HasPermission } from "../../services/hasPermission";

import {
  fetchBranchData,
  initBranchState,
} from "../../redux/slices/branchSlice";

import {
  fetchDepartmentData,
  initDepartState,
} from "../../redux/slices/departmentSlice.js";

// Redux slices
import {
  getAttendOptions,
  saveMoreSettings,
  getAttendOptionsOne,
  saveMoreSettingsOne,
  initMoreSettState,
} from "../../redux/slices/moreSettings";
import {
  commonGetDataOne,
  commonGetDataTwo,
  commonGetDataFourth,
  commonGetDataThird,
  commonSaveData,
  initCommonState,
} from "../../redux/slices/commonSlice";
import {
  getAttendModule,
  initAttModule,
} from "../../redux/slices/moreSettings";
import {
  initEmpState,
  getEmployeeData,
} from "../../redux/slices/employeeSlice";
// API Config
import {
  deleteAttendanceModulePath,
  getAttendanceModulePath,
  getStaffAttendanceListPath,
  assignEmployeeAttendancePath,
  getAttendOptionsPath,
  fetchLeavePath,
  attendanceGeneralSettingsPath,
  getEmployeeManageListPath,
  getAttendanceGeneralSettingsPath,
} from "../../services/config";
import Widgets from "../../components/Widgets";
import WidgetsIcon from "../../components/Widgets/icon";
import WidgetsButton from "../../components/Widgets/button";
import AssignEmployee from "../../components/AssignEmployee";

import { useGlobalToast } from "../../stopOldToastGlobally.js";

const MultiAttendance = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const store = useSelector((state) => state.moreSettings);
  const commonStore = useSelector((state) => state.common);
  const branchStore = useSelector((state) => state.branch);
  const departmentStore = useSelector((state) => state.department);
  const toast = useGlobalToast();

  const [state, setState] = useState({
    showDeleteModal: false,
    showAssignModal: false,
    deleteId: null,
    attendance_id: "",
    outletName: "",
    selectedUsers: [],
    searchQuery: "",
    branchId: "",
    departmentId: "",
  });

  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [createValue, setCreateValue] = useState("1");
  const [assignState, setAssignState] = useState({
    branchId: "",
    departmentId: "",
  });
const theme = localStorage.getItem("theme");
  const [moduleList, setModuleList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getModule = useCallback(() => {
    dispatch(getAttendModule(`${getAttendanceModulePath}${user.user_id}`));
    dispatch(fetchBranchData());
    dispatch(fetchDepartmentData(user.user_id));
  }, [dispatch, user.user_id]);

  const getEmployeeList = useCallback(
    (attendanceId) => {
      const path = getStaffAttendanceListPath(user.user_id, attendanceId, state.branchId, state.departmentId);
      dispatch(commonGetDataFourth(path));
    },
    []
  );

  useEffect(() => {
    const path = getStaffAttendanceListPath(user.user_id, state.attendance_id, state.branchId, state.departmentId);
    dispatch(commonGetDataFourth(path));
  }, [state.branchId, state.departmentId])

  useEffect(() => {
    getModule();
  }, [getModule]);

  const handleDelete = (id) =>
    setState((prev) => ({ ...prev, deleteId: id, showDeleteModal: true }));

  const handleDeleteSubmit = () => {
    dispatch(
      commonSaveData({
        path: deleteAttendanceModulePath,
        data: {
          userId: user.user_id,
          attendanceId: state.deleteId,
        },
      })
    );
    setState((prev) => ({ ...prev, showDeleteModal: false }));
  };

  const [outletName, setOutletName] = useState("");

  const handleAssignId = (data) => {
    setOutletName(data.moduleName);
    setState((prev) => ({
      ...prev,
      attendance_id: data.attendanceId,
      outletName: data.moduleName,
      showAssignModal: true,
    }));
    getEmployeeList(data.attendanceId);
  };

  const handleAssignModalClose = () => {
    setState((prev) => ({
      ...prev,
      showAssignModal: false,
      selectedUsers: [],
      searchQuery: "",
      branchId: "",
      departmentId: "",
    }));
    setSelectedUsersList([]);
  };
  const handleDeleteModalClose = () =>
    setState((prev) => ({ ...prev, showDeleteModal: false }));

  const selectUser = (e, staffId, user) => {
    const isChecked = e.target.checked;
    setState((prev) => ({
      ...prev,
      selectedUsers: isChecked
        ? [...prev.selectedUsers, staffId]
        : prev.selectedUsers.filter((id) => id !== staffId),
    }));
    setSelectedUsersList((prevSelected) =>
      isChecked
        ? [...prevSelected, user]
        : prevSelected.filter((u) => u.staffId !== user.staffId)
    );
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setState((preState) => ({
      ...preState,
      [name]: value,
    }));
  };

  const toggleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setState((prev) => ({
      ...prev,
      selectedUsers: isChecked ? employeeList.map((row) => row.staffId) : [],
    }));
    const allUserList = employeeList.map((row) => row);
    if (isChecked) {
      setSelectedUsersList(allUserList);
    } else {
      setSelectedUsersList([]);
    }
  };

  const isSelectAll =
    state.selectedUsers.length === employeeList.length &&
    employeeList.length > 0;

  const searchEmployees = (val, dataList) => {
    setState((prev) => ({ ...prev, searchQuery: val }));
    const filterData = dataList.filter(
      (v) =>
        v.full_name.toLowerCase().includes(val.toLowerCase()) ||
        v.employee_id.toLowerCase().includes(val.toLowerCase())
    )
    setEmployeeList(filterData);
    setFilterEmployeeList(dataList);
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    dispatch(
      commonSaveData({
        path: assignEmployeeAttendancePath,
        data: {
          userId: user.user_id,
          staffId: state.selectedUsers.toString(),
          attendanceId: state.attendance_id,
        },
      })
    );
  };

  useEffect(() => {
    if (store.mSetGetAttModSuccess) {
      setModuleList(store.mSetGetAttModData);
      dispatch(initAttModule());
    }

    if (store.mSetSuccess || store.umSetSuccess) {
      // toast.success(store.mSetMessage)
      getModule();
      setIsCreate(false);
      setIsUpdate(false);
    }

    if (commonStore.commonSuccess) {
      toast.success(commonStore.commonMessage);
      getModule();
      handleAssignModalClose();
      dispatch(initCommonState());
    }

    if (commonStore.commonError) {
      toast.error(commonStore.commonMessage);
      handleAssignModalClose();
      dispatch(initCommonState());
    }

    if (commonStore.commonGetFourthSuccess) {
      const data = commonStore.commonGetFourthData;
      if (state.searchQuery != "") {
        searchEmployees(state.searchQuery, data)
      } else {
        setEmployeeList(data);
        setFilterEmployeeList(data);
        setState((prev) => ({
          ...prev,
          selectedUsers: data
            ?.filter((v) => v.attendanceAssignedStatus === "1")
            .map((v) => v.staffId),
        }));
        const list = data
          ?.filter((v) => v.attendanceAssignedStatus === "1")
          .map((v) => v);
        setSelectedUsersList(list);
        dispatch(initCommonState());
      }
    }
  }, [store, commonStore, dispatch, getModule]);

  const getAttendanceDetails = useCallback((id) => {
    let url = `${getAttendanceGeneralSettingsPath}${id}`;
    dispatch(commonGetDataThird(url));
  }, []);

  const [updateData, setUpdatedData] = useState(null);

  useEffect(() => {
    if (commonStore.commonGetThirdSuccess) {
      if (commonStore.commonGetThirdData.moduleName) {
        setUpdatedData(commonStore.commonGetThirdData);
      }
    }
    if (departmentStore.depGetSuccess) {
      setDepartmentList(departmentStore.depGetData);
      dispatch(initDepartState());
    }

    if (branchStore.brnGetSuccess) {
      setBranchList(branchStore.brnGetData);
      dispatch(initBranchState());
    }
  }, [commonStore, departmentStore, branchStore, dispatch]);

  const [updateId, setUpdateId] = useState("");
  const handleUpdateSetting = (id) => {
    getAttendanceDetails(id);
    setUpdateId(id);
    setIsUpdate(true);
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: "S.No",
        field: "serial",
        width: 80,
        sortable: false,
        filter: false,
        suppressMovable: true,
        cellStyle: {
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "500",
          padding: "0px",
        },
        headerClass: "text-center",
        valueGetter: (params) => params.node.rowIndex + 1,
      },
      {
        headerName: "Module Name",
        field: "moduleName",
        flex: 1,
        minWidth: 200,
        cellStyle: {
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          paddingLeft: "15px",
        },
        headerClass: "text-left",
      },
      {
        headerName: "Action",
        width: 180,
        cellStyle: {
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px",
        },
        headerClass: "text-center",
        cellRenderer: (params) => {
          const data = params.data;
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                width: "100%",
                height: "100%",
                padding: "0px",
                margin: "0px",
              }}
            >
              {HasPermission("Attendance Settings", "create") && (
                <PiUserCheck
                  style={{
                    cursor: "pointer",
                    fontSize: "24px",
                    color: "green",
                    margin: "0px",
                    padding: "0px",
                  }}
                  className="assign-icon"
                  onClick={() => handleAssignId(data)}
                />
              )}

              {HasPermission("Attendance Settings", "edit") && (
                <PiPencilSimpleLineBold
                  style={{
                    cursor: "pointer",
                    fontSize: "24px",
                    color: "#666",
                    margin: "0px",
                    padding: "0px",
                  }}
                  className="edit-icon"
                  onClick={() => handleUpdateSetting(data.attendanceId)}
                />
              )}

              {HasPermission("Attendance Settings", "delete") && (
                <RiDeleteBinLine className="delete-icon"
                  style={{
                    cursor: "pointer",
                    fontSize: "24px",
                    color: "red",
                    margin: "0px",
                    padding: "0px",
                  }}
                  onClick={() => handleDelete(data.attendanceId)}
                />
              )}

              {!HasPermission("Attendance Settings", "approve") &&
                !HasPermission("Attendance Settings", "edit") &&
                !HasPermission("Attendance Settings", "delete") &&
                <span style={{ margin: "0px", padding: "0px" }}>-</span>}
            </div>
          );
        },
      },
    ],
    []
  );

  const [bacPath, setBackPath] = useState("")
  useEffect(() => {
    if (localStorage.getItem("emp-redirect")) {
      setBackPath(localStorage.getItem("emp-redirect"))
    } else {
      setBackPath("/setting/")
    }
  }, [])

  return (
    <>
      {/* Header */}
      <div
        style={{
          position: "fixed",
          top: "76px",
          width: "100%",
          height: "calc(100vh - 76px)",
          overflow: "auto",
        }}
      >
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to={bacPath}>
                  <ArrowBackIcon className="icon-color" />
                </Link>
              }
              title="Attendance Module"
            />
          }
          button={
            HasPermission("Attendance Settings", "create") && (
              <button
                className="universal-btn border-radius-8px "
                onClick={() => setIsCreate(true)}
              >
                <AddIcon /> Create Attendance Module
              </button>

            )
          }
         // Replace this section in MultiAttendance component:

body={
  <>
    <div
      style={{
        height: "calc(100vh - 220px)",  // leave room for pagination
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
      }}
    >
      {/* AG Grid fills remaining space */}
      <div
        className="ag-theme-quartz custom-grid mt-2"
        style={{
          flex: 1,
          overflow: "hidden",
          '--ag-cell-horizontal-padding': '8px',
          '--ag-header-cell-horizontal-padding': '8px',
          '--ag-row-height': '48px',
          '--ag-header-height': '48px',
        }}
      >
        <AgGridReact
          rowData={Array.isArray(moduleList) ? moduleList : []}
          columnDefs={columnDefs}
          pagination={false}        // ← DISABLE built-in pagination
          onGridReady={onGridReady}
          rowHeight={48}
          headerHeight={48}
          suppressCellFocus={true}
          defaultColDef={{
            resizable: true,
            sortable: false,
            filter: false,
            suppressMenu: true,
          }}
          onFirstDataRendered={(params) => {
            params.api.sizeColumnsToFit();
          }}
        />
      </div>
    </div>

    {/* Pagination OUTSIDE scroll — pinned to bottom */}
    <div
  style={{
    position: "sticky",
    bottom: 0,
    background: theme === "light" ? "#ffffff" : "#1a1726",  // ← theme-aware
    borderTop: theme === "light" ? "1px solid #e0e0e0" : "1px solid #2d2845",
    padding: "8px 20px",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
  }}
>
     {gridApi && <CustomPagination gridApi={gridApi} />}

    </div>
  </>
}
        />

        {/* Button + Table */}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <AssignEmployee
        isOpen={state.showAssignModal}
        closeOpenDialog={handleAssignModalClose}
        submitData={handleAssignShiftSubmit}
        isSelectAll={isSelectAll}
        SelectAll={toggleSelectAll}
        selectedUsersList={selectedUsersList}
        employeeList={employeeList}        // ← This should contain employees
        selectedUsers={state.selectedUsers}
        selectUser={selectUser}
        branchList={branchList}
        departmentList={departmentList}
        state={state}
        handleInputChange={handleInputChange}
        getData={""}
        searchQuery={state.searchQuery}
        searchEmployees={searchEmployees}
        outletName={outletName}
        dataList={filterEmployeeList}
      />

      {/* Delete Confirmation Modal */}
      <Modal
        show={state.showDeleteModal}
        onHide={handleDeleteModalClose}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Module</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this module?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteSubmit}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <CreateAttendance isCreate={isCreate} setIsCreate={setIsCreate} />

      {/* Create new Attendance Module */}

      {/* Update Attendance Module */}
      {updateData != null && (
        <UpdateSettings
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          updateId={updateId}
          updateData={updateData}
        />
      )}
    </>
  );
};

export default React.memo(MultiAttendance);

// -------------------------------------------
const CreateAttendance = ({ isCreate, setIsCreate }) => {
  const [user] = useState(JSON.parse(localStorage.getItem("user_data")));
  const dispatch = useDispatch();
  const store = useSelector((state) => state.moreSettings);
  const commonSateStore = useSelector((state) => state.common);
  const toast = useGlobalToast();

  const [mainTabIndex, setMainTabIndex] = useState(0);
  const [attendOptions, setAttendOptions] = useState([]);
  const [moduleNameRequired, setModuleNameRequired] = useState(false);
  const [state, setState] = useState({
    userId: user.user_id,
    moduleId: "",
    moduleName: "",
    employeeLocation: 1,
    regularizeAttendDays: "",
    regularizeAttendYear: "",
    reasonForPermission: "",
    reqularizeUpto: "",
    reasonForLate: "",
    permissionAvailDays: "",
    permissionAvailYears: "",
    reasonForPermission: "",
    lateArrivalMinutes: "",
    reasonForLate: "",
    earlyCheckoutMinutes: "",
    reasonForEarly: "",
    mandatoryApprovalRequest: "",
    mandatoryApprovalYears: "",
    gracePeriodHours: "",
    allowEmpRegAfterClockOut: "",
    enableOvertimePolicy: "",
    offSitePermissions: "",
    offSitePermissionEnable: "",
    isEnableRegularizeSettings: "",
    empRequestRegularize: "",
    regularizePeriodMax: "",
    regularizeAttendDays: "",
    regularizeAttendDate: "",
    exceedRegularizeRequest: "",
    orderOfLeaveRequest: "",
    isFaceEnable: "",
    isLocationEnable: "",
    autoClockOut: "",
    offSitePermissions3: "",
    isLogout: "",
    isEnableBranchGeoFence: "",
    offSiteEnable: "",
    annualLeave: "",
    onSiteReasonList: [
      {
        reasonName: "",
      },
    ],
    onSiteEndReasonList: [
      {
        reasonName: "",
      },
    ],
    regularizeReasonList: [
      {
        reasonName: "",
      },
    ],
    permissionReasonList: [
      {
        reasonName: "",
      },
    ],
    lateReasonList: [
      {
        reasonName: "",
      },
    ],
    earlyCheckOutReasonList: [
      {
        reasonName: "",
      },
    ],
    trackLocationTime: "",
    reasonForPermission: "",
    allowHalfDays: "",
    allowHalfDaysYears: "",
    approvalSettings: [
      {
        staffId: "",
        assigneeName: "",
        roleId: "",
        isSkipStep: false,
        skipStep: 0,
      },
    ],
    moduleError: false,
    approveDays: 0,

    l1Days: "",
    l1IsAutoPassApproval: "0",

    l2Days: "",
    l2IsAutoPassApproval: "0",

    l3Days: "",
    l3IsAutoPassApproval: "0",
  });

  const [saveLeaves, setSaveLeaves] = useState({
    list: [],
  });

  const [leaveList, setLeaveList] = useState([]);
  const [validated, setValidated] = useState(false);
  const [createValue, setCreateValue] = useState("1");

  // Tabs variables ===========================
  const fetchAttendOptions = useCallback(() => {
    let path = getAttendOptionsPath;
    dispatch(getAttendOptions(path));
  }, []);

  useEffect(() => {
    fetchAttendOptions();
  }, []);

  useEffect(() => {
    if (store.mSetGetAttSuccess) {
      setAttendOptions(store.mSetGetAttData);
    }
  }, [store.mSetGetAttSuccess]);

  const getLeaveList = useCallback(() => {
    let path = `${fetchLeavePath}${user.user_id}`;
    dispatch(commonGetDataOne(path));
  }, []);

  useEffect(() => {
    getLeaveList();
  }, []);

  useEffect(() => {
    if (commonSateStore.commonGetOneSuccess) {
      if (
        Array.isArray(commonSateStore.commonGetOneData) &&
        commonSateStore.commonGetOneData.length > 0
      ) {
        const listArray = commonSateStore.commonGetOneData.map((val) => {
          return {
            label: val.leaveName,
            value: val.leaveId,
          };
        });
        setLeaveList(listArray);
        dispatch(initCommonState());
      }
    }
  }, [commonSateStore.commonGetOneSuccess]);

  const handleLeavesChange = (e) => {
    setSaveLeaves({
      ...saveLeaves,
      list: e,
    });
    setState({
      ...state,
      moduleError: false,
    });
  };

  const handleRegularizeChange = (e) => {
    const {
      target: { name, checked },
    } = e;
    setState({
      ...state,
      isEnableRegularizeSettings: checked ? 1 : 0,
    });
  };

  const getModuleData = () => {
    let url = `${getAttendanceModulePath}${user.user_id}`;
    dispatch(commonGetDataTwo(url));
  };
  useEffect(() => {
    getModuleData();
  }, []);

  const mainHandleChange = (e) => {
    const {
      target: { name, value },
    } = e;
    if (name === "moduleName") {
      setModuleNameRequired(false);
    }
    if (name === "offSitePermissionEnable") {
      setState({
        ...state,
        offSitePermissionEnable: e.target.checked,
      });
    } else {
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const mainHandleChecked = (event) => {
    const {
      target: { name, checked },
    } = event;

    if (name == "isLogout") {
      if (!checked) {
        setState({
          ...state,
          offSiteEnable: "",
        });
      }
    }

    setState({
      ...state,
      [name]: checked ? 1 : 0,
    });
  };

  const beforeSubmitSettingData = () => {
    const elm = document.getElementById("submit-module");
    if (elm) {
      elm.click();
    }
  };

  const submitSettingData = (e) => {
    const form = e.currentTarget;
    if (state.moduleName == "" || state.moduleName == null) {
      toast.error("Module Name is required");
      setModuleNameRequired(true);
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      let data = {
        path: attendanceGeneralSettingsPath,
        data: {
          userId: user.user_id,
          moduleId: state.moduleId,
          moduleName: state.moduleName,
          employeeLocation: state.employeeLocation,
          regularizeAttendDays: state.regularizeAttendDays,
          regularizeAttendYear: state.regularizeAttendYear,
          reasonForPermission: state.reasonForPermission,
          reqularizeUpto: state.reqularizeUpto,
          reasonForLate: state.reasonForLate,
          permissionAvailDays: state.permissionAvailDays,
          permissionAvailYears: state.permissionAvailYears,
          reasonForPermission: state.reasonForPermission,
          lateArrivalMinutes: state.lateArrivalMinutes,
          reasonForLate: state.reasonForLate,
          earlyCheckoutMinutes: state.earlyCheckoutMinutes,
          reasonForEarly: state.reasonForEarly,
          mandatoryApprovalRequest: state.mandatoryApprovalRequest,
          mandatoryApprovalYears: state.mandatoryApprovalYears,
          gracePeriodHours: state.gracePeriodHours,
          allowEmpRegAfterClockOut: state.allowEmpRegAfterClockOut,
          enableOvertimePolicy: state.enableOvertimePolicy,
          offSitePermissions: state.offSitePermissions,
          offSitePermissionEnable: state.offSitePermissionEnable,
          isEnableRegularizeSettings: state.isEnableRegularizeSettings,
          empRequestRegularize: state.empRequestRegularize,
          regularizePeriodMax: state.regularizePeriodMax,
          regularizeAttendDays: state.regularizeAttendDays,
          regularizeAttendDate: state.regularizeAttendDate,
          exceedRegularizeRequest: state.exceedRegularizeRequest,
          orderOfLeaveRequest: saveLeaves.list
            .map((v) => {
              return v.value;
            })
            .toString(),
          isFaceEnable: state.isFaceEnable,
          isLocationEnable: state.isLocationEnable,
          autoClockOut: state.autoClockOut,
          offSiteEnable: state.offSiteEnable,
          isEnableBranchGeoFence: state.isLogout,
          annualLeave: state.annualLeave,
          onSiteReasonList: state.onSiteReasonList,
          onSiteEndReasonList: state.onSiteEndReasonList,
          regularizeReasonList: state.regularizeReasonList,
          permissionReasonList: state.permissionReasonList,
          lateReasonList: state.lateReasonList,
          earlyCheckOutReasonList: state.earlyCheckOutReasonList,
          trackLocationTime: state.trackLocationTime,
          reasonForPermission: state.reasonForPermission,
          allowHalfDays: state.allowHalfDays,
          allowHalfDaysYears: state.allowHalfDaysYears,
          approvalSettings: state.approvalSettings,
          rmLevels: {
            rmL1Days: state.l1Days,
            rmL1Approve: state.l1IsAutoPassApproval, // 1 - Auto approve 2- pass
            rmL2Days: state.l2Day,
            rmL2Approve: state.l2IsAutoPassApproval,
            rmL3Days: state.l3Days,
            rmL3Approve: state.l3IsAutoPassApproval,
          },
        },
      };
      dispatch(saveMoreSettings(data));
    }
  };

  useEffect(() => {
    if (store.mSetSuccess) {
      toast.success(store.mSetMessage);
      dispatch(initMoreSettState());
    }
    if (store.mSetError) {
      toast.error(store.mSetMessage);
      dispatch(initMoreSettState());
    }
  }, [store.mSetSuccess, store.mSetError]);

  // Create and update attendance module
  const handleCreateChange = (event, newValue) => {
    setCreateValue(newValue);
  };

  const handleCloseCreateAttendance = () => {
    setIsCreate(false)
    setCreateValue("1");
  }

  const theme = localStorage.getItem("theme")

  // Current Components ------------------------------
  return (
    <Dialog
      open={isCreate}
      onClose={handleCloseCreateAttendance}
      fullWidth={true}
      maxWidth={"lg"}
      style={{ overflow: "visible" }}
      className="dark-bg-color"
    >
      <DialogTitle id="alert-dialog-title" className="dialog-title">
        <div className="dialog-title-icon">
          <span className="close-icon" onClick={handleCloseCreateAttendance}>
            X
          </span>
          <span className="title">Create Attendance Module</span>
        </div>
        <button className="universal-btn" onClick={beforeSubmitSettingData}>
          Submit
        </button>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={createValue}>
            {/* MODULE NAME SECTION - ABOVE TABS (LIKE UPDATE) */}
            <Box sx={{
              marginBottom: "20px",
              paddingBottom: "10px",
              borderBottom: theme === "light" ? "1px solid #e0e0e0" : "1px solid #444"
            }}>
              <Form
                noValidate
                validated={validated}
                onSubmit={submitSettingData}
              >
                <Form.Group style={{ margin: 0 }}>
                  <Form.Label
                    style={{
                      color: theme === "light" ? "#333" : "#ffffff",
                      fontWeight: "600",
                      marginBottom: "8px",
                      display: "block",
                      textAlign: "left",
                      fontSize: "16px"
                    }}
                  >
                    Module Name
                  </Form.Label>
                  <Form.Control
                    name="moduleName"
                    value={state.moduleName}
                    onChange={mainHandleChange}
                    placeholder="Enter module name"
                    required
                    style={{
                      backgroundColor: theme === "light" ? "#c2c5c8c4" : "#1906285d",
                      border: theme === "light" ? "1px solid #ddd" : "1px solid #444",
                      borderRadius: "8px",
                      padding: "10px 15px",
                      textAlign: "left",
                      width: "100%",
                      maxWidth: "300px",
                      color: theme === "light" ? "#333" : "#ffffff85",
                      fontSize: "14px"
                    }}
                  />
                  {moduleNameRequired && (
                    <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
                      Module name is required
                    </span>
                  )}
                  <Form.Control.Feedback type="invalid">
                    Module name is required
                  </Form.Control.Feedback>
                </Form.Group>
                <button
                  type="submit"
                  id="submit-module"
                  style={{ display: "none" }}
                ></button>
              </Form>
            </Box>

            {/* TABS SECTION */}
            <Box sx={{ borderBottom: "1px solid gray", marginBottom: "10px" }}>
              <TabList
                onChange={handleCreateChange}
                aria-label="lab API tabs example"
                textColor="inherit"
                indicatorColor="none"
                sx={{
                  "& .MuiTab-root": {
                    color: theme == "light" ?
                      "#000 !important" : "#fff !important",
                    fontWeight: "500",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px"
                  },
                  "& .Mui-selected": {
                    color: theme == "light" ?
                      "#313030ff !important" : "#8660F8 !important",
                    fontWeight: "600"
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: theme == "light" ?
                      "#313030ff !important" : "#8660F8 !important",
                    height: "3px"
                  },
                }}
              >
                <Tab label="General Setting" value="1" />
                <Tab label="Regularization" value="2" />
                <Tab label="Permission Settings" value="3" />
                <Tab label="Approval Chain" value="4" />
              
              </TabList>
            </Box>

            {/* TAB PANELS - WITH PROPER PADDING LIKE UPDATE */}
            <TabPanel value="1" sx={{ padding: 0 }}>
              <Box sx={{ width: "100%", margin: "0" }}>
                <GeneralSetting
                  mainHandleChange={mainHandleChange}
                  mainHandleChecked={mainHandleChecked}
                  setMainTabIndex={setMainTabIndex}
                  mainState={state}
                  setMainState={setState}
                  setCreateValue={setCreateValue}
                />
              </Box>
            </TabPanel>

            <TabPanel value="2" sx={{ padding: 0 }}>
              <Box sx={{ width: "100%", margin: "0" }}>
                <AttendanceRegularization
                  attendOptions={attendOptions}
                  mainHandleChange={mainHandleChange}
                  mainState={state}
                  setMainTabIndex={setMainTabIndex}
                  setMainState={setState}
                  handleRegularizeChange={handleRegularizeChange}
                  leaveList={leaveList}
                  handleLeavesChange={handleLeavesChange}
                  saveLeaves={saveLeaves}
                  setSaveLeaves={setSaveLeaves}
                  setCreateValue={setCreateValue}
                />
              </Box>
            </TabPanel>

            <TabPanel value="3" sx={{ padding: 0 }}>
              <Box sx={{ width: "100%", margin: "0" }}>
                <LateCheckInEarlyCheckOut
                  attendOptions={attendOptions}
                  mainHandleChange={mainHandleChange}
                  mainState={state}
                  setMainTabIndex={setMainTabIndex}
                  setMainState={setState}
                  setCreateValue={setCreateValue}
                />
              </Box>
            </TabPanel>

            <TabPanel value="4" sx={{ padding: 0 }}>
              <Box sx={{ width: "100%", margin: "0" }}>
                <ApprovalChain
                  attendOptions={attendOptions}
                  mainHandleChange={mainHandleChange}
                  setMainTabIndex={setMainTabIndex}
                  mainState={state}
                  setMainState={setState}
                  setCreateValue={setCreateValue}
                />
              </Box>
            </TabPanel>

            {/* <TabPanel value="5" sx={{ padding: 0 }}>
              <Box sx={{ width: "100%", margin: "0" }}>
                <OvertimeSettings />
                <Row>
                  <Col sm="12" style={{ padding: "0", display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "20px" }}>
                    <CustomButton
                      type={"button"}
                      class_name="p_btn universal-input-one"
                      text={"Back"}
                      url_or_onclick={() => setCreateValue("4")}
                      icon={null}
                      width="150px"
                    />
                    <CustomButton
                      type={"button"}
                      class_name="p_btn universal-btn"
                      text={"Submit"}
                      url_or_onclick={beforeSubmitSettingData}
                      icon={null}
                      width="150px"
                    />
                  </Col>
                </Row>
              </Box>
            </TabPanel> */}
          </TabContext>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const GeneralSetting = ({
  mainHandleChange,
  mainHandleChecked,
  setMainTabIndex,
  mainState,
  setMainState,
  setCreateValue,

}) => {
  const [isFaceEnableChecked, setIsFaceEnableChecked] = useState(false);
  const [isLocationEnableChecked, setIsLocationEnableChecked] = useState(false);
  const [isAutoClockOut, setIsAutoClockOut] = useState(false);
  const [isOnSite, setIsOnSite] = useState(false);

  const handleChecked = (event) => {
    const {
      target: { name, checked },
    } = event;
    if (name == "isLocationEnable") {
      setIsLocationEnableChecked(checked);
    }
    if (name == "isFaceEnable") {
      setIsFaceEnableChecked(checked);
    }
    if (name == "autoClockOut") {
      setIsAutoClockOut(checked);
    }
    if (name == "offSiteEnable") {
      setIsOnSite(checked);
    }
  };
  const addOnSiteReason = () => {
    const newReason = { reasonName: "" };
    setMainState((prevState) => ({
      ...prevState,
      onSiteReasonList: [...prevState.onSiteReasonList, newReason],
    }));
  };

  const removeOnSiteReason = (idx) => {
    const newArr = [...mainState.onSiteReasonList];
    newArr.splice(idx, 1);
    setMainState({
      ...mainState,
      onSiteReasonList: newArr,
    });
  };

  const handleOnSiteReason = (e, idx) => {
    const {
      target: { value, name },
    } = e;
    const newArr = [...mainState.onSiteReasonList];
    newArr[idx][name] = value;

    setMainState({
      ...mainState,
      onSiteReasonList: newArr,
    });
  };

  const addOnSiteEndReason = () => {
    const newReason = { reasonName: "" };
    setMainState((prevState) => ({
      ...prevState,
      onSiteEndReasonList: [newReason, ...prevState.onSiteEndReasonList],
    }));
  };

  const removeOnSiteEndReason = (idx) => {
    const newArr = [...mainState.onSiteEndReasonList];
    newArr.splice(idx, 1);
    setMainState({
      ...mainState,
      onSiteEndReasonList: newArr,
    });
  };

  const handleOnSiteEndReason = (e, idx) => {
    const {
      target: { value, name },
    } = e;
    const newArr = [...mainState.onSiteEndReasonList];
    newArr[idx][name] = value;

    setMainState({
      ...mainState,
      onSiteEndReasonList: newArr,
    });
  };

  const submitHandle = (e) => {
    e.preventDefault();
  };

  const handleRadioBtn = (e) => {
    const { value } = e.target;
    setMainState({
      ...mainState,
      offSitePermissions: value,
    });
  };

  return (
    <div
      className="more-setting-form-container"
      style={{ backgroundColor: "transparent" }}
    >
      <Form
        className="form"
        onSubmit={submitHandle}
        style={{ padding: "0 10px" }}
      >
        <Form.Group className="mb-4">
          <Row>
            <Col sm="12" className="flex-form universal-bg-color">
              <div style={{ cursor: "default" }}>
                <b className="universal-bg-colors">
                  Mark Attendance form
                  <div className="MarkAttendanceform-radio-card">
                    <div
                      className="MarkAttendanceform-radio"
                      onClick={() => {
                        const event = { target: { name: "employeeLocation", value: "1" } };
                        mainHandleChange(event);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        name="employeeLocation"
                        type="radio"
                        value="1"
                        onChange={(e) => {
                          mainHandleChange(e);
                        }}
                        checked={mainState.employeeLocation == "1"}
                        style={{ cursor: "pointer" }}
                        id="location-assigned"
                      />
                      <label
                        htmlFor="location-assigned"
                        style={{ cursor: "pointer" }}
                      >
                        Only in Assigned Location
                      </label>
                    </div>
                    <div
                      className="MarkAttendanceform-radio"
                      onClick={() => {
                        const event = { target: { name: "employeeLocation", value: "2" } };
                        mainHandleChange(event);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        name="employeeLocation"
                        type="radio"
                        value="2"
                        onChange={(e) => {
                          mainHandleChange(e);
                        }}
                        checked={mainState.employeeLocation == "2"}
                        style={{ cursor: "pointer" }}
                        id="location-anywhere"
                      />
                      <label
                        htmlFor="location-anywhere"
                        style={{ cursor: "pointer" }}
                      >
                        From Anywhere
                      </label>
                    </div>
                  </div>
                </b>
              </div>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className="flex-form mb-3 universal-bg-color "
              style={{ justifyContent: "space-between" }}
            >
              <label>Enable AI Face Recognition Setting &nbsp;</label>
              <Switch
                name="isFaceEnable"
                checked={isFaceEnableChecked}
                onChange={(e) => {
                  handleChecked(e);
                  mainHandleChecked(e);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className="flex-form mb-3 universal-bg-color "
              style={{ justifyContent: "space-between" }}
            >
              <label>Track Location Permission &nbsp;</label>
              <Switch
                name="isLocationEnable"
                checked={isLocationEnableChecked}
                onChange={(e) => {
                  handleChecked(e);
                  mainHandleChecked(e);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className="flex-form mb-3 universal-bg-color "
              style={{ justifyContent: "space-between" }}
            >
              <label style={{ textWrap: "nowrap" }}>
                Employees annual leaves &nbsp;
              </label>
              <Form.Control
                name="annualLeave"
                value={mainState.annualLeave}
                onChange={(e) => {
                  mainHandleChange(e);
                }}
                placeholder="Employees annual leaves"
                inputProps={{ "aria-label": "controlled" }}
                className="universal-input "
              />
            </Col>
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>
        {/*  */}

        {/* <Form.Group>
          <Row>
            <Col sm={12} className="flex-form mb-3 universal-bg-color">
              <label>Track Location Every &nbsp;</label>
              <Form.Control
                name="trackLocationTime"
                value={mainState.trackLocationTime}
                onChange={(e) => {
                  mainHandleChange(e);
                }}
                style={{ width: "200px" }}
                placeholder="Enter minutes"
              />
              <label> &nbsp;&nbsp;Minutes</label>
            </Col>
          </Row>
        </Form.Group> */}

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className=" mb-3"
              style={{
                border: "1px solid lightgray",
                borderRadius: "7px",
                padding: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <label className="color-white">
                  Enable Auto Clock-Out &nbsp;
                </label>
                <Switch
                  name="autoClockOut"
                  checked={isAutoClockOut}
                  onChange={(e) => {
                    handleChecked(e);
                    mainHandleChecked(e);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>

              <span
                style={{
                  position: "relative",
                  marginTop: "10px",
                  fontSize: "14px",
                  color: "gray",
                }}
              >
                Automatically clock out employees if they fail to clock out
                after their shift ends.
              </span>
            </Col>
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        {isAutoClockOut && (
          <div className={isAutoClockOut ? "drop-container" : "container-hide"}>
            <Form.Group>
              <Row>
                <Col
                  sm={12}
                  className="mb-3 universal-bg-color "
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="mb-3 universal-bg-color "
                  >
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Grace Period (in hours) &nbsp;
                    </label>
                    <Form.Control
                      name="gracePeriodHours"
                      placeholder="Enter number of hours (e.g., 2)"
                      onChange={mainHandleChange}
                      className="universal-input"
                    />
                  </div>
                  <span
                    style={{
                      position: "relative",
                      top: "5px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Specify the number of hours after shift end for auto
                    clock-out to activate.
                  </span>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Field is required
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Row>
                <Col
                  sm={12}
                  className="mb-3 universal-bg-color "
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="universal-bg-color "
                  >
                    <label>
                      Allow Employees to Regularize Attendance After Auto
                      Clock-Out &nbsp;
                    </label>
                    <Switch
                      name="allowEmpRegAfterClockOut"
                      checked={
                        mainState.allowEmpRegAfterClockOut == 1 ? true : false
                      }
                      onChange={(e) => {
                        handleChecked(e);
                        mainHandleChecked(e);
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                  <span
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      color: "gray",
                    }}
                    className="mb-3 universal-bg-color "
                  >
                    Do Not Allow Regularization After Auto Clock-Out.
                  </span>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Field is required
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Row>
                <Col
                  sm={12}
                  className="mb-3 universal-bg-color "
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="universal-bg-color "
                  >
                    <label>Enable Overtime Policy Exception &nbsp;</label>
                    <Switch
                      name="enableOvertimePolicy"
                      checked={
                        mainState.enableOvertimePolicy == 1 ? true : false
                      }
                      onChange={(e) => {
                        handleChecked(e);
                        mainHandleChecked(e);
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                  <span
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Exclude employees with assigned overtime policies from Auto
                    Clock-Out.
                  </span>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Field is required
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        )}

        <Form.Group>
          <Row>
            <Col
              sm="12"
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <label>
                Logout When the employee moves out of the Branch Geo
                Fencing&nbsp;
              </label>
              <Switch
                name="isLogout"
                checked={
                  mainState.isLogout == "1" ||
                    mainState.isEnableBranchGeoFence == 1
                    ? true
                    : false
                }
                onChange={(e) => {
                  handleChecked(e);
                  mainHandleChecked(e);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
        </Form.Group>

        {mainState.isLogout == "1" && (
          <Form.Group>
            <Row>
              <Col
                sm={12}
                className="flex-form mb-3 universal-bg-color"
                style={{ justifyContent: "space-between" }}
              >
                <label className="color-white">Enable Off Site &nbsp;</label>
                <Switch
                  name="offSiteEnable"
                  checked={mainState.offSiteEnable == 1 ? true : false}
                  onChange={(e) => {
                    handleChecked(e);
                    mainHandleChecked(e);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Col>
            </Row>
            <Form.Control.Feedback type={"invalid"}>
              Field is required
            </Form.Control.Feedback>
          </Form.Group>
        )}

        {mainState.offSiteEnable == 1 && (
          <div
            className={
              mainState.offSiteEnable == 1 ? "drop-container" : "container-hide"
            }
          >
            {/* {mainState.onSiteReasonList.map((row, idx) => {
              return (
                <Form.Group key={idx}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handleOnSiteReason(e, idx);
                          }}
                          placeholder="Reason for off site"
                          required
                        />
                        {idx == 0 && (
                          <FaRegSquarePlus
                            onClick={addOnSiteReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx != 0 && (
                          <FiMinusSquare
                            onClick={() => removeOnSiteReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })} */}

            {mainState.onSiteReasonList.map((row, idx) => {
              return (
                idx != 0 && (
                  <Form.Group key={idx}>
                    <Row>
                      <Col
                        sm={12}
                        className="flex-form mb-3 universal-bg-color"
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "start",
                            gap: "10px",
                          }}
                        >
                          <Form.Control
                            name="reasonName"
                            value={row.reasonName}
                            onChange={(e) => {
                              handleOnSiteReason(e, idx);
                            }}
                            placeholder="On site start reason"
                            required
                            className="universal-input"
                          />
                          {/* endReasonName */}
                          {idx === 0 && ( // Keep the add button at the top
                            <FaRegSquarePlus
                              onClick={addOnSiteReason}
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "skyblue",
                              }}
                            />
                          )}
                          {idx !== 0 && (
                            <FiMinusSquare
                              onClick={() => removeOnSiteReason(idx)}
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "red",
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Form.Control.Feedback type={"invalid"}>
                      Reason is required.
                    </Form.Control.Feedback>
                  </Form.Group>
                )
              );
            })}

            <Form.Group key={0}>
              <Row>
                <Col sm={12} className="flex-form mb-3 universal-bg-color">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <Form.Control
                      name="reasonName"
                      value={mainState.onSiteReasonList[0].reasonName}
                      onChange={(e) => {
                        handleOnSiteReason(e, 0);
                      }}
                      placeholder="On site start reason"
                      required
                      className="universal-input"
                    />
                    {/* endReasonName */}

                    <FaRegSquarePlus
                      onClick={addOnSiteReason}
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "skyblue",
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Reason is required.
              </Form.Control.Feedback>
            </Form.Group>

            {mainState.onSiteEndReasonList.map((row, idx) => {
              return (
                idx != 0 && (
                  <Form.Group key={idx}>
                    <Row>
                      <Col
                        sm={12}
                        className="flex-form mb-3 universal-bg-color"
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "start",
                            gap: "10px",
                          }}
                        >
                          <Form.Control
                            name="reasonName"
                            value={row.reasonName}
                            onChange={(e) => {
                              handleOnSiteEndReason(e, idx);
                            }}
                            placeholder="On site end reason"
                            required
                            className="universal-input"
                          />

                          {idx === 0 && (
                            <FaRegSquarePlus
                              onClick={addOnSiteEndReason}
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "skyblue",
                              }}
                            />
                          )}
                          {idx !== 0 && (
                            <FiMinusSquare
                              onClick={() => removeOnSiteEndReason(idx)}
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "red",
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Form.Control.Feedback type={"invalid"}>
                      Reason is required.
                    </Form.Control.Feedback>
                  </Form.Group>
                )
              );
            })}

            <Form.Group key={0}>
              <Row>
                <Col sm={12} className="flex-form mb-3 universal-bg-color">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <Form.Control
                      name="reasonName"
                      value={mainState.onSiteEndReasonList[0].reasonName}
                      onChange={(e) => {
                        handleOnSiteEndReason(e, 0);
                      }}
                      placeholder="On site end reason"
                      required
                      className="universal-input"
                    />
                    {/* endReasonName */}

                    <FaRegSquarePlus
                      onClick={addOnSiteEndReason}
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "skyblue",
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Reason is required.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  gap: "10px",
                }}
              >
                <Form.Check
                  type="radio"
                  name="offSitePermissions"
                  id="offSitePermissions1"
                  value={"1"}
                  label={
                    <label
                      style={{ cursor: "pointer" }}
                      className="color-white"
                      htmlFor="offSitePermissions1"
                    >
                      Require employees to return to the office to log out.
                    </label>
                  }
                  onChange={handleRadioBtn}
                />
                <Form.Check
                  type="radio"
                  name="offSitePermissions"
                  id="offSitePermissions2"
                  value={"2"}
                  label={
                    <label
                      style={{ cursor: "pointer" }} className="color-white"
                      htmlFor="offSitePermissions2"
                    >
                      Allow employees to log out from any location.
                    </label>
                  }
                  onChange={handleRadioBtn}
                />
              </div>

              <br />
              <br />
              <div
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "7px",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <label className="color-white">
                    Mandatory Approval for Off Site Requests &nbsp;
                  </label>
                  <Switch
                    name="offSitePermissions3"
                    checked={mainState.offSitePermissions3 == 1 ? true : false}
                    onChange={(e) => {
                      handleChecked(e);
                      mainHandleChecked(e);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                <span
                  style={{
                    position: "relative",
                    fontSize: "13px",
                    color: "gray",
                  }}
                >
                  All Off Site requests will require manager approval. Managers
                  must approve or reject each request based on tracked details.
                </span>
              </div>

              {/* <Form.Check
                  type="radio"
                  name="offSitePermissions"
                  id="offSitePermissions3"
                  value={"3"}
                  label={
                    <label
                      style={{ cursor: "pointer" }}
                      htmlFor="offSitePermissions3"
                    >
                      Mandatory Approval for Off Site Requests:
                    </label>
                  }
                  onChange={handleRadioBtn}
                /> */}

              <br />

              {mainState.offSitePermissions3 == 1 && (
                <>
                  <span
                    style={{
                      marginTop: "20px",
                      fontSize: "13px",
                      color: "gray",
                    }}
                  >
                    If this option is disabled, the system will not deduct any
                    hours or apply LOP for Off Site requests, and they will be
                    automatically approved without manager intervention.
                  </span>
                  <Form.Check
                    name="offSitePermissionEnable"
                    onChange={mainHandleChange}
                    label="Yes / No"
                    className="color-white"
                  />
                  <span
                    style={{
                      marginTop: "20px",
                      fontSize: "13px",
                      color: "gray",
                    }}
                  >
                    Note: Disabling this feature means employees on Off Site
                    will not be subject to attendance or leave deductions
                    regardless of their geofence activity.
                  </span>
                </>
              )}
            </Form.Group>
          </div>
        )}

        {/* BIOMETRIC SECTION =========================== */}
        <Form.Group>
          <Row>
            <Col
              sm={12}
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <label>
                <MdFingerprint /> Biometric Attendance &nbsp;
              </label>
              <Switch
                checked={false}
                onChange={() => {
                  mainHandleChange;
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
        </Form.Group>

        <Row>
          <Col
            sm="12"
            style={{
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <CustomButton
              type={"button"}
              class_name="p_btn universal-input-one"
              text={"Next"}
              url_or_onclick={() => setCreateValue("2")}
              icon={null}
              width="150px"
            />
          </Col>
        </Row>

        {/* <Row>
            <Col sm="3" style={{ padding: "0" }}>
              <CustomButton
                type={"submit"}
                class_name="p_btn"
                text={store.mSetLoading ? "Submitting..." : "Submit"}
                url_or_onclick={null}
                icon={null}
                width="150px"
              />
            </Col>
          </Row> */}
      </Form>
    </div>
  );
};

const AttendanceRegularization = ({
  attendOptions,
  mainHandleChange,
  mainState,
  setMainTabIndex,
  setMainState,
  handleRegularizeChange,
  leaveList,
  handleLeavesChange,
  saveLeaves,
  setSaveLeaves,
  setCreateValue,
}) => {
  const addRegularizePermissionReason = () => {
    const newArr = [...mainState.regularizeReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, regularizeReasonList: newArr });
  };
  const removeRegularizePermissionReason = (index) => {
    const newArr = [...mainState.regularizeReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, regularizeReasonList: newArr });
  };
  const handleRegularizePermission = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.regularizeReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, regularizeReasonList: newArr });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "100%", // Set your desired width here
    }),
  };
  const allSelected = leaveList.length === saveLeaves.list.length;
  const [menuOpen, setMenuOpen] = useState(false);
  // ==================================================================
  return (
    <div
      className="more-setting-form-container"
      style={{ backgroundColor: "transparent" }}
    >
      <Form className="form" onSubmit={handleSubmit} d>
        <Form.Group>
          <Row>
            <Form.Label className="color-white">
              Regularization Policy Settings
            </Form.Label>

            <Col
              sm="12"
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <span>
                Allow employees to regularise attendance when discrepancies
                occur
              </span>

              <Switch
                label="Check"
                checked={
                  mainState.isEnableRegularizeSettings == 1 ? true : false
                }
                onChange={handleRegularizeChange}
              />
            </Col>

            {mainState.isEnableRegularizeSettings == 1 && (
              <div
                className={
                  mainState.isEnableRegularizeSettings == 1
                    ? "drop-container"
                    : null
                }
              >
                <Col
                  sm={12}
                  className="mb-3"
                  style={{
                    // border: "0.5px solid lightgray",
                    // borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">
                      Select how often employees can request regularization.
                      &nbsp;
                    </label>
                    &nbsp;&nbsp;
                    <Form.Select
                      name="empRequestRegularize"
                      value={mainState.empRequestRegularize}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      style={{ width: "270px" }}
                      className="universal-input-one"
                    >
                      <option value="">Select an option</option>
                      {attendOptions.map((row, idx) => {
                        return (
                          <option value={row.id} key={idx}>
                            {row.options}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </div>

                  {/* <span
                    style={{
                      position: "relative",
                      marginTop: "10px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Select how often employees can request regularization.
                  </span> */}
                </Col>

                <Col
                  sm="12"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                  className="mb-3"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Specify the maximum number of regularization requests
                      allowed within the selected period &nbsp;
                    </label>
                    <Form.Control
                      style={{ width: "100%" }}
                      placeholder="Enter here"
                      name="regularizePeriodMax"
                      value={mainState.regularizePeriodMax}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="universal-input-one"
                    />
                  </div>
                  {/* <span
                    style={{
                      position: "relative",
                      marginTop: "10px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Specify the maximum number of regularization requests
                    allowed within the selected period.
                  </span> */}
                </Col>

                {mainState.regularizePeriodMax &&
                  mainState.regularizeReasonList.map((row, idx) => {
                    return (
                      <Form.Group key={idx}>
                        <Row style={{ padding: "0 10px" }}>
                          <Col
                            sm={12}
                            className="flex-form mb-3 universal-bg-color"
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "start",
                                gap: "10px",
                              }}
                            >
                              <Form.Control
                                name="reasonName"
                                value={row.reasonName}
                                onChange={(e) => {
                                  handleRegularizePermission(e, idx);
                                }}
                                placeholder="Reason for regularize"
                                required
                                className="universal-input-one"
                              />
                              {idx == 0 && (
                                <FaRegSquarePlus
                                  onClick={addRegularizePermissionReason}
                                  style={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "skyblue",
                                  }}
                                />
                              )}
                              {idx != 0 && (
                                <FiMinusSquare
                                  onClick={() =>
                                    removeRegularizePermissionReason(idx)
                                  }
                                  style={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                />
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Form.Control.Feedback type={"invalid"}>
                          Reason for permission is required.
                        </Form.Control.Feedback>
                      </Form.Group>
                    );
                  })}

                <Col
                  sm="12"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                  className="mb-3"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Apply Regularisation Within &nbsp;
                    </label>
                    <Form.Control
                      style={{ width: "100%" }}
                      placeholder="Enter here"
                      name="regularizeAttendDays"
                      value={mainState.regularizeAttendDays}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="universal-input-one"
                    />
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Days &nbsp;
                    </label>
                  </div>
                  {/* <span
                    style={{
                      position: "relative",
                      marginTop: "10px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Specify the maximum number of regularization requests
                    allowed within the selected period.
                  </span> */}
                  {/* </Col>

                <Col
                  sm={12}
                  className="mb-3"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                > */}

                  <br />
                  <center className="color-white">OR</center>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">
                      Set a deadline for submitting regularization requests
                      after an attendance discrepancy is identified. &nbsp;
                    </label>
                    &nbsp;&nbsp;
                    <Form.Select
                      name="regularizeAttendDate"
                      value={mainState.regularizeAttendDate}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      style={{ width: "170px" }}
                      className="universal-input-one"
                    >
                      <option value="" key={0}>
                        Select Date
                      </option>
                      <option value="1" key={1}>
                        1
                      </option>
                      <option value="2" key={2}>
                        2
                      </option>
                      <option value="3" key={3}>
                        3
                      </option>
                      <option value="4" key={4}>
                        4
                      </option>
                      <option value="5" key={5}>
                        5
                      </option>
                      <option value="6" key={6}>
                        6
                      </option>
                      <option value="7" key={7}>
                        7
                      </option>
                      <option value="8" key={8}>
                        8
                      </option>
                      <option value="9" key={9}>
                        9
                      </option>
                      <option value="10" key={10}>
                        10
                      </option>
                      <option value="11" key={11}>
                        11
                      </option>
                      <option value="12" key={12}>
                        12
                      </option>
                      <option value="13" key={13}>
                        13
                      </option>
                      <option value="14" key={14}>
                        14
                      </option>
                      <option value="15" key={15}>
                        15
                      </option>
                      <option value="16" key={16}>
                        16
                      </option>
                      <option value="17" key={17}>
                        17
                      </option>
                      <option value="18" key={18}>
                        18
                      </option>
                      <option value="19" key={19}>
                        19
                      </option>
                      <option value="20" key={20}>
                        20
                      </option>
                      <option value="21" key={21}>
                        21
                      </option>
                      <option value="22" key={22}>
                        22
                      </option>
                      <option value="23" key={23}>
                        23
                      </option>
                      <option value="24" key={24}>
                        24
                      </option>
                      <option value="25" key={25}>
                        25
                      </option>
                      <option value="26" key={26}>
                        26
                      </option>
                      <option value="27" key={27}>
                        27
                      </option>
                      <option value="28" key={28}>
                        28
                      </option>
                      <option value="29" key={29}>
                        29
                      </option>
                      <option value="30" key={30}>
                        30
                      </option>
                      <option value="31" key={31}>
                        31
                      </option>
                    </Form.Select>
                  </div>

                  {/* <span
                    style={{
                      position: "relative",
                      marginTop: "10px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Set a deadline for submitting regularization requests after
                    an attendance discrepancy is identified.
                  </span> */}
                </Col>

                <Col
                  sm={12}
                  className="mb-3"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">
                      Action for Exceeding Regularisation Requests&nbsp;
                    </label>
                    &nbsp;&nbsp;
                    <Form.Select
                      name="exceedRegularizeRequest"
                      value={mainState.exceedRegularizeRequest}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      style={{ width: "270px" }}
                      className="universal-input-one"
                    >
                      <option value="" key={0}>
                        Select an option
                      </option>
                      <option value="1" key={1}>
                        Require Special Permission
                      </option>
                      <option value="2" key={2}>
                        Mark as Leave Without Pay (LOP)
                      </option>
                      <option value="3" key={3}>
                        Deduct from Leave Balance
                      </option>
                    </Form.Select>
                  </div>

                  {/* <span
                    style={{
                      position: "relative",
                      marginTop: "10px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Select the order of leave deduction if regularisation
                    requests exceed the allowed limit
                  </span> */}
                </Col>

                {mainState.exceedRegularizeRequest == 3 && (
                  <Col
                    sm={12}
                    className="mb-3"
                    style={{
                      border: "1px solid lightgray",
                      borderRadius: "7px",
                      padding: "20px 10px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        gap: "10px",
                        border: mainState.moduleError && "1px solid red",
                      }}
                    >
                      <label className="color-white">
                        Select the order of leave deduction if regularisation{" "}
                        <br />
                        requests exceed the allowed limit &nbsp;
                      </label>
                      &nbsp;&nbsp;
                      <MultiSelect
                        value={saveLeaves.list}
                        labelledBy="Select Leaves"
                        options={leaveList}
                        onChange={handleLeavesChange}
                        style={{ width: "100%" }}
                        className="custom-multi-select m-select"
                      />
                    </div>

                    <span
                      style={{
                        position: "relative",
                        marginTop: "10px",
                        fontSize: "14px",
                        color: "gray",
                      }}
                    ></span>
                  </Col>
                )}
              </div>
            )}


            {/* <div class="dropdown-content">
              <div class="panel-content">
                <div class="select-panel" role="listbox">
                  <div class="search">
                    <input placeholder="Search" type="text" aria-describedby="Search" tabindex="0" value="" />
                    <button type="button" class="search-clear-button" hidden="" aria-label="Clear Search">
                      <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" class="dropdown-search-clear-icon gray">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                  <ul class="options">
                    <label class="select-item " role="option" aria-selected="false" tabindex="1">
                      <div class="item-renderer "><input type="checkbox" tabindex="-1" />
                        <span>Select All</span>
                      </div>
                    </label>
                    <li>
                      <label class="select-item selected" role="option" aria-selected="true" tabindex="2">
                        <div class="item-renderer ">
                          <input type="checkbox" tabindex="-1" checked="" />
                          <span>Casual Leave</span>
                        </div>
                      </label>
                    </li>
                    <li>
                      <label class="select-item " role="option" aria-selected="false" tabindex="3">
                        <div class="item-renderer ">
                          <input type="checkbox" tabindex="-1" />
                          <span>Emergency Leave</span>
                        </div>
                      </label>
                    </li>
                    <li>
                      <label class="select-item " role="option" aria-selected="false" tabindex="4">
                        <div class="item-renderer ">
                          <input type="checkbox" tabindex="-1" />
                          <span>Sick Leave</span>
                        </div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}


          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        {/* <Form.Group>
          <Row>
            <Col sm={12} className="flex-form mb-3 universal-bg-color">
              <label>Employees Can regularise attendance upto &nbsp;</label>
              <Form.Control
                name="reqularizeUpto"
                value={mainState.reqularizeUpto}
                onChange={(e) => {
                  mainHandleChange(e);
                }}
                style={{ width: "200px" }}
                placeholder="Enter days"
              />
            </Col>
          </Row>
        </Form.Group> */}

        <Row>
          <Col
            sm="12"
            style={{
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            className="pb-5"
          >
            <CustomButton
              type={"button"}
              class_name="p_btn universal-input-one"
              text={"Back"}
              url_or_onclick={() => setCreateValue("1")}
              icon={null}
              width="150px"
            />

            <CustomButton
              type={"button"}
              class_name="p_btn universal-input-one"
              text={"Next"}
              url_or_onclick={() => setCreateValue("3")}
              icon={null}
              width="150px"
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

const LateCheckInEarlyCheckOut = ({
  attendOptions,
  mainHandleChange,
  mainState,
  setMainTabIndex,
  setMainState,
  setCreateValue,
}) => {
  const addPermissionReason = () => {
    const newArr = [...mainState.permissionReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, permissionReasonList: newArr });
  };
  const removePermissionReason = (index) => {
    const newArr = [...mainState.permissionReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, permissionReasonList: newArr });
  };

  const handlePermission = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.permissionReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, permissionReasonList: newArr });
  };
  // Late reason ==============================
  const [lateReason, setLateReason] = useState([{ reasonName: "" }]);

  const addLateReason = () => {
    const newArr = [...mainState.lateReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, lateReasonList: newArr });
  };
  const removeLateReason = (index) => {
    const newArr = [...mainState.lateReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, lateReasonList: newArr });
  };

  const handleLateReason = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.lateReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, lateReasonList: newArr });
  };

  // Early reason ==============================

  const addEarlyReason = () => {
    const newArr = [...mainState.earlyCheckOutReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, earlyCheckOutReasonList: newArr });
  };
  const removeEarlyReason = (index) => {
    const newArr = [...mainState.earlyCheckOutReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, earlyCheckOutReasonList: newArr });
  };

  const handleEarlyReason = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.earlyCheckOutReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, earlyCheckOutReasonList: newArr });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <div
        className="more-setting-form-container"
        style={{ backgroundColor: "transparent" }}
      >
        <Form className="form" onSubmit={handleSubmit}>
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Permissions can be availed for &nbsp;</label>
                <Form.Control
                  name="permissionAvailDays"
                  value={mainState.permissionAvailDays}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  placeholder="ex:5"
                  style={{ width: "80px" }}
                  className="universal-input-one"
                />
                <label>&nbsp;&nbsp;days in a&nbsp;&nbsp;</label>
                <Form.Select
                  name="permissionAvailYears"
                  value={mainState.permissionAvailYears}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "170px" }}
                  className="universal-input-one"
                >
                  <option value="">Select an option</option>
                  {attendOptions.map((row, idx) => {
                    return (
                      <option value={row.id} key={idx}>
                        {row.options}
                      </option>
                    );
                  })}
                </Form.Select>
              </Col>
            </Row>
            <Form.Control.Feedback type={"invalid"}>
              Field is required
            </Form.Control.Feedback>
          </Form.Group>

          {mainState.permissionAvailDays != "" &&
            mainState.permissionAvailYears != "" &&
            mainState.permissionReasonList.map((row, idx) => {
              return (
                <Form.Group key={idx}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handlePermission(e, idx);
                          }}
                          placeholder="Reason for permission"
                          required
                          className="universal-input-one"
                        />
                        {idx == 0 && (
                          <FaRegSquarePlus
                            onClick={addPermissionReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx != 0 && (
                          <FiMinusSquare
                            onClick={() => removePermissionReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason for permission is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Late Arrival of &nbsp;</label>
                <Form.Control
                  name="lateArrivalMinutes"
                  value={mainState.lateArrivalMinutes}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "200px" }}
                  placeholder="Enter minutes"
                  className="universal-input-one"
                />
                <label>&nbsp; Minutes is allowed per request</label>
              </Col>
            </Row>
          </Form.Group>

          {mainState.lateArrivalMinutes != "" &&
            mainState.lateReasonList.map((row, idx) => {
              return (
                <Form.Group key={idx}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handleLateReason(e, idx);
                          }}
                          placeholder="Reason for Late"
                          required
                          className="universal-input-one"
                        />
                        {idx == 0 && (
                          <FaRegSquarePlus
                            onClick={addLateReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx != 0 && (
                          <FiMinusSquare
                            onClick={() => removeLateReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason for permission is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}

          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Early Check Out of &nbsp;</label>
                <Form.Control
                  name="earlyCheckoutMinutes"
                  value={mainState.earlyCheckoutMinutes}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "200px" }}
                  placeholder="Enter minutes"
                  className="universal-input-one"
                />
                <label>&nbsp; Minutes is allowed per request</label>
              </Col>
            </Row>
          </Form.Group>

          {mainState.earlyCheckoutMinutes != "" &&
            mainState.earlyCheckOutReasonList.map((row, idx) => {
              return (
                <Form.Group key={idx}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handleEarlyReason(e, idx);
                          }}
                          placeholder="Reason for Early"
                          required
                          className="universal-input-one"
                        />
                        {idx == 0 && (
                          <FaRegSquarePlus
                            onClick={addEarlyReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx != 0 && (
                          <FiMinusSquare
                            onClick={() => removeEarlyReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason for permission is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}

          <Row>
            <Col
              sm="12"
              style={{
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Back"}
                url_or_onclick={() => setCreateValue("2")}
                icon={null}
                width="150px"
              />

              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Next"}
                url_or_onclick={() => setCreateValue("4")}
                icon={null}
                width="150px"
              />
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

const ApprovalChain = ({
  attendOptions,
  mainHandleChange,
  setMainTabIndex,
  mainState,
  setMainState,
  setCreateValue,
}) => {
  const [user] = useState(JSON.parse(localStorage.getItem("user_data")));
  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);
  const empStore = useSelector((state) => state.employee);

  const [staffList, setStaffList] = useState([]);

  const getStaffList = useCallback(() => {
    const path = `${getEmployeeManageListPath}${user.user_id}`;
    dispatch(getEmployeeData(path));
  }, []);

  useEffect(() => {
    getStaffList();
  }, []);

  useEffect(() => {
    if (empStore.empGetSuccess) {
      setStaffList(empStore.empGetData);
      dispatch(initEmpState());
    }
  }, [empStore.empGetSuccess]);

  const [assignees, setAssignees] = useState([
    {
      staffId: "",
      assigneeName: "",
      roleId: "",
      isSkipStep: false,
      skipStep: 0,
    },
  ]);

  const addMoreAssignees = () => {
    const newAssignees = [...mainState.approvalSettings];
    newAssignees.push({
      staffId: "",
      assigneeName: "",
      roleId: "",
      isSkipStep: false,
      skipStep: 0,
      preference: 0,
    });
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const removeLevel = (id) => {
    const newAssignees = [...mainState.approvalSettings];

    newAssignees.splice(id, 1);
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleApprovalChange = (e, idx) => {
    const {
      target: { value },
    } = e;
    const data = JSON.parse(value);
    const newAssignees = [...mainState.approvalSettings];
    newAssignees[idx].staffId = data.staffId;
    newAssignees[idx].assigneeName = data.full_name;
    newAssignees[idx].roleId = data.emp_role;
    newAssignees[idx].preference = parseInt(idx) + 1;

    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleSkipCheckChange = (e, idx) => {
    const {
      target: { checked },
    } = e;
    const newAssignees = [...mainState.approvalSettings];
    newAssignees[idx].isSkipStep = checked ? true : false;
    newAssignees[idx].skipStep = 0;
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleCheckChange = (e, idx) => {
    const {
      target: { value },
    } = e;
    const newAssignees = [...mainState.approvalSettings];
    newAssignees[idx].skipStep = value;
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleApproveDays = (event) => {
    setMainState({
      ...mainState,
      approveDays: event.target.checked ? 1 : 0,
    });
  };

  return (
    <>
      <div
        className="more-setting-form-container"
        style={{
          position: "relative",
          height: "auto",
          paddingBottom: "50px",
          backgroundColor: "transparent",
        }}
      >
        <Form className="form" onSubmit={handleSubmit}>
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Mandatory Approval required if request exceeds</label>
                <Form.Control
                  name="mandatoryApprovalRequest"
                  value={mainState.mandatoryApprovalRequest}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  placeholder="ex:5"
                  style={{ width: "80px" }}
                  className="universal-input-one"
                />
                <label>&nbsp;times in a&nbsp;</label>
                <Form.Select
                  name="mandatoryApprovalYears"
                  value={mainState.mandatoryApprovalYears}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "170px" }}
                  className="universal-input-one"
                >
                  <option value="">Select an option</option>
                  {attendOptions.map((row, idx) => {
                    return (
                      <option value={row.id} key={idx}>
                        {row.options}
                      </option>
                    );
                  })}
                </Form.Select>
              </Col>
            </Row>
            <Form.Control.Feedback type={"invalid"}>
              Field is required
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Row
              className="flex-form mb-5"
              style={{ backgroundColor: "transparent" }}
            >
              <Col sm="12" className="p-0 mb-2">
                <div className="color-white">Reporting Manager Level</div>
              </Col>
              <Col sm={12} className="p-0 mb-2 approval-con">
                <h4 className="color-white mt-2 mb-">Level 1</h4>
                <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                  <div>
                    <Form.Label className="color-white">
                      If Level 1 Manager does not respond within
                    </Form.Label>
                  </div>
                  <div>
                    <Form.Control
                      name="l1Days"
                      value={mainState.l1Days}
                      placeholder="ex:5"
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="universal-input-one"
                      style={{ width: "100px" }}
                    />
                  </div>
                  <div>
                    <Form.Label className="color-white">days</Form.Label>
                  </div>
                </Form.Group>

                <Form.Group className="d-flex align-items-center justify-content-start gap-2 mb-2">
                  {/* <Form.Label className="color-white">Select An Option</Form.Label> */}
                  <Form.Check
                    type="radio"
                    name="l1IsAutoPassApproval"
                    label="Auto Approval"
                    value={"1"}
                    checked={mainState.l1IsAutoPassApproval == "1"}
                    onChange={(e) => {
                      mainHandleChange(e);
                    }}
                    className="color-white"
                  />
                  <span
                    className="color-white"
                    style={{ position: "relative", top: "-3px" }}
                  >
                    OR
                  </span>
                  <Form.Check
                    type="radio"
                    name="l1IsAutoPassApproval"
                    label="Escalate  to level 2"
                    value={"2"}
                    checked={mainState.l1IsAutoPassApproval == "2"}
                    onChange={(e) => {
                      mainHandleChange(e);
                    }}
                    className="color-white"
                  />
                </Form.Group>
              </Col>

              {mainState.l1IsAutoPassApproval == "2" && (
                <Col
                  sm={12}
                  className="p-0 mb-3 approval-con"
                  style={{ borderTop: "1px solid gray" }}
                >
                  <h4 className="color-white mt-2 mb-">Level 2</h4>
                  <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                    <div>
                      <Form.Label className="color-white">
                        If Level 2 Manager does not respond within
                      </Form.Label>
                    </div>
                    <div>
                      <Form.Control
                        name="l2Days"
                        value={mainState.l2Days}
                        placeholder="ex:5"
                        onChange={(e) => {
                          mainHandleChange(e);
                        }}
                        className="universal-input-one"
                        style={{ width: "100px" }}
                      />
                    </div>
                    <div>
                      <Form.Label className="color-white">days</Form.Label>
                    </div>
                  </Form.Group>

                  <Form.Group className="d-flex align-items-center justify-content-start gap-2 mb-2">
                    {/* <Form.Label className="color-white">Select An Option</Form.Label> */}
                    <Form.Check
                      type="radio"
                      name="l2IsAutoPassApproval"
                      label="Auto Approval"
                      value={"1"}
                      checked={mainState.l2IsAutoPassApproval == "1"}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="color-white"
                    />
                    <span
                      className="color-white"
                      style={{ position: "relative", top: "-3px" }}
                    >
                      OR
                    </span>
                    <Form.Check
                      type="radio"
                      name="l2IsAutoPassApproval"
                      label="Escalate  to level 3"
                      value={"2"}
                      checked={mainState.l2IsAutoPassApproval == "2"}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="color-white"
                    />
                  </Form.Group>
                </Col>
              )}

              {mainState.l2IsAutoPassApproval == "2" && (
                <Col
                  sm={12}
                  className="p-0 mb-3 approval-con"
                  style={{ borderTop: "1px solid gray" }}
                >
                  <h4 className="color-white mt-2">Level 3</h4>
                  <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                    <div>
                      <Form.Label className="color-white">
                        If Level 3 Manager does not respond within
                      </Form.Label>
                    </div>
                    <div>
                      <Form.Control
                        name="l3Days"
                        value={mainState.l3Days}
                        placeholder="ex:5"
                        onChange={(e) => {
                          mainHandleChange(e);
                        }}
                        className="universal-input-one"
                        style={{ width: "100px" }}
                      />
                    </div>
                    <div>
                      <Form.Label className="color-white">days</Form.Label>
                    </div>
                  </Form.Group>

                  <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                    {/* <Form.Label className="color-white">Select An Option</Form.Label> */}
                    <Form.Check
                      type="radio"
                      name="l3IsAutoPassApproval"
                      label="Auto Approval"
                      value={"1"}
                      checked={mainState.l3IsAutoPassApproval == "1"}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="color-white"
                    />
                    {/* <Form.Check
                      type="radio"
                      name="l3IsAutoPassApproval"
                      label="Escalate  to level 2"
                      value={"2"}
                      checked={mainState.l3IsAutoPassApproval == "2"}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="color-white"
                    /> */}
                  </Form.Group>
                </Col>
              )}

              {/* {mainState.approvalSettings.map((row, idx) => {
                return <h3>Mani</h3>;
              })} */}

              {/* Add assignee */}
              {/* <Col key={idx} sm={12} className="p-0 mb-3 approval-con">
                    <Card
                      style={{ width: "100%", backgroundColor: "transparent" }}
                    >
                      <Card.Header
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span className="color-white">
                          Level {idx + 1}
                          <b> Approval</b>
                        </span>
                        {idx != 0 && (
                          <RiDeleteBin6Line
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => removeLevel(idx)}
                          />
                        )}
                      </Card.Header>
                      <Card.Body>
                        <Card.Text>
                          <Form.Label className="color-white">
                            Assignees
                          </Form.Label>
                          <Form.Select
                            placeholder="Role / Employee"
                            onChange={(e) => {
                              handleApprovalChange(e, idx);
                            }}
                            className="universal-input-one"
                          >
                            <option value="">Role / Employee</option>
                            {staffList?.map((row, idx) => {
                              return (
                                <option
                                  value={JSON.stringify({
                                    staffId: row.staffId,
                                    emp_role: row.emp_role,
                                    full_name: row.full_name,
                                  })}
                                  key={idx}
                                >
                                  {row.full_name}
                                </option>
                              );
                            })}
                          </Form.Select>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              paddingTop: "20px",
                            }}
                          >
                            <Form.Check
                              className="color-white"
                              label="Skip step if no action taken in"
                              onChange={(e) => handleSkipCheckChange(e, idx)}
                            />

                            <InputGroup
                              style={{
                                width: "110px",
                              }}
                            >
                              <Form.Control
                                placeholder="ex:5"
                                onChange={(e) => handleCheckChange(e, idx)}
                                readOnly={row.isSkipStep ? false : true}
                                className="universal-input-one"
                              />
                              <InputGroup.Text
                                id="basic-addon1"
                                className="universal-input-one"
                              >
                                days
                              </InputGroup.Text>
                            </InputGroup>
                          </div>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                    <div className="ver-line"></div>
                  </Col> */}

              {/* <Col sm="12" className="p-0 mt-2 mb-3">
                <Form.Group>
                  <Form.Check
                    label="Check out approve days"
                    onChange={handleApproveDays}
                    className="color-white"
                  />
                </Form.Group>
              </Col>

              <Col sm="5" className="p-0 mt-2">
                <Button
                  variant="outline-primary"
                  style={{ width: "150px", marginTop: "-16px" }}
                  onClick={addMoreAssignees}
                >
                  Add More Level
                </Button>
              </Col> */}
            </Row>
          </Form.Group>

          <Row>
            <Col
              sm="12"
              style={{
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Back"}
                url_or_onclick={() => setCreateValue("3")}
                icon={null}
                width="150px"
              />

              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Next"}
                url_or_onclick={() => setCreateValue("5")}
                icon={null}
                width="150px"
              />
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};


// Update Attendance settings ---------------------------------------------

const UpdateSettings = ({ isUpdate, setIsUpdate, updateId, updateData }) => {
  const user = useMemo(
    () => JSON.parse(localStorage.getItem("user_data")) || {},
    []
  );
  const dispatch = useDispatch();
  const store = useSelector((state) => state.moreSettings);
  const commonSateStore = useSelector((state) => state.common);
  const toast = useGlobalToast();

  const [mainTabIndex, setMainTabIndex] = useState(0);
  const [attendOptions, setAttendOptions] = useState([]);
  const [state, setState] = useState({
    userId: user.user_id,
    moduleId: "",
    moduleName: "",
    employeeLocation: "",
    regularizeAttendDays: "",
    regularizeAttendYear: "",
    reasonForPermission: "",
    reqularizeUpto: "",
    reasonForLate: "",
    permissionAvailDays: "",
    permissionAvailYears: "",
    reasonForPermission: "",
    lateArrivalMinutes: "",
    reasonForLate: "",
    earlyCheckoutMinutes: "",
    reasonForEarly: "",
    mandatoryApprovalRequest: "",
    mandatoryApprovalYears: "",
    gracePeriodHours: "",
    allowEmpRegAfterClockOut: "",
    enableOvertimePolicy: "",
    offSitePermissions: "",
    offSitePermissionEnable: "",
    isEnableRegularizeSettings: "",
    empRequestRegularize: "",
    regularizePeriodMax: "",
    regularizeAttendDays: "",
    regularizeAttendDate: "",
    exceedRegularizeRequest: "",
    orderOfLeaveRequest: "",
    isFaceEnable: "",
    isLocationEnable: "",
    offSitePermissions3: "",
    isLogout: "",
    autoClockOut: "",
    offSiteEnable: "",
    isEnableBranchGeoFence: "",
    annualLeave: "",
    onSiteReasonList: [
      {
        reasonName: "",
      },
    ],
    onSiteEndReasonList: [
      {
        reasonName: "",
      },
    ],
    regularizeReasonList: [
      {
        reasonName: "",
      },
    ],
    permissionReasonList: [
      {
        reasonName: "",
      },
    ],
    lateReasonList: [
      {
        reasonName: "",
      },
    ],
    earlyCheckOutReasonList: [
      {
        reasonName: "",
      },
    ],
    trackLocationTime: "",
    reasonForPermission: "",
    allowHalfDays: "",
    allowHalfDaysYears: "",
    approvalSettings: [
      {
        staffId: "",
        assigneeName: "",
        roleId: "",
        isSkipStep: false,
        skipStep: 0,
      },
    ],
    moduleError: false,
    approveDays: "",

    l1Days: "",
    l1IsAutoPassApproval: "0",

    l2Days: "",
    l2IsAutoPassApproval: "0",

    l3Days: "",
    l3IsAutoPassApproval: "0",
  });
  const [saveLeaves, setSaveLeaves] = useState({
    list: [],
  });
  const [validated, setValidated] = useState(false);

  const fetchAttendOptions = useCallback(() => {
    let path = getAttendOptionsPath;
    dispatch(getAttendOptionsOne(path));
  }, []);

  useEffect(() => {
    fetchAttendOptions();
  }, []);

  useEffect(() => {
    if (store.umSetGetAttSuccess) {
      setAttendOptions(store.umSetGetAttData);
    }
  }, [store.umSetGetAttSuccess]);

  const getAttendanceDetails = useCallback(() => {
    let url = `${getAttendanceGeneralSettingsPath}${updateId}`;
    dispatch(commonGetDataThird(url));
  }, [updateId]);

  useEffect(() => {
    getAttendanceDetails();
  }, []);

  useEffect(() => {
    const data = updateData;

    const updatedState = {
      ...state,
      moduleId: updateId,
      moduleName: data.moduleName,
      userId: user.user_id,
      employeeLocation: data.employeeLocation,
      regularizeAttendDays: data.regularizeAttendDays,
      regularizeAttendYear: data.regularizeAttendYear,
      reasonForPermission: data.reasonForPermission,
      reqularizeUpto: data.reqularizeUpto,
      reasonForLate: data.reasonForLate,
      permissionAvailDays: data.permissionAvailDays,
      permissionAvailYears: data.permissionAvailYears,
      lateArrivalMinutes: data.lateArrivalMinutes,
      earlyCheckoutMinutes: data.earlyCheckoutMinutes,
      reasonForEarly: data.reasonForEarly,
      mandatoryApprovalRequest: data.mandatoryApprovalRequest,
      mandatoryApprovalYears: data.mandatoryApprovalYears,
      gracePeriodHours: data.gracePeriodHours,
      allowEmpRegAfterClockOut: data.allowEmpRegAfterClockOut,
      enableOvertimePolicy: data.enableOvertimePolicy,
      offSitePermissions: data.offSitePermissions,
      offSitePermissionEnable: data.offSitePermissionEnable,
      offSitePermissions3: data.offSitePermissionEnable,
      isEnableRegularizeSettings: data.isEnableRegularizeSettings,
      empRequestRegularize: data.empRequestRegularize,
      regularizePeriodMax: data.regularizePeriodMax,
      regularizeAttendDate: data.regularizeAttendDate,
      exceedRegularizeRequest: data.exceedRegularizeRequest,
      orderOfLeaveRequest: data.orderOfLeaveRequest,
      isFaceEnable: data.isFaceEnable,
      isLocationEnable: data.isLocationEnable,
      autoClockOut: data.autoClockOut,
      offSiteEnable: data.offSiteEnable,
      trackLocationTime: data.trackLocationTime,
      allowHalfDays: data.allowHalfDays,
      allowHalfDaysYears: data.allowHalfDaysYears,
      isLogout: data.isEnableBranchGeoFence,
      isEnableBranchGeoFence: data.isEnableBranchGeoFence,
      // rmLevels: {
      //   rmL1Days: data.rmLevels.rmL1Days,
      //   rmL1Approve: data.rmLevels.rmL1Approve, // 1 - Auto approve 2- pass
      //   rmL2Days: data.rmLevels.rmL2Days,
      //   rmL2Approve: data.rmLevels.rmL2Approve,
      //   rmL3Days: data.rmLevels.rmL3Days,
      //   rmL3Approve: data.rmLevels.rmL3Approve,
      // },

      l1Days: data.rmLevels.rmL1Days,
      l1IsAutoPassApproval: data.rmLevels.rmL1Approve,

      l2Days: data.rmLevels.rmL2Days,
      l2IsAutoPassApproval: data.rmLevels.rmL2Approve,

      l3Days: data.rmLevels.rmL3Days,
      l3IsAutoPassApproval: data.rmLevels.rmL3Approve,
    };

    if (
      Array.isArray(data?.onSiteReasonList) &&
      data.onSiteReasonList.length > 0
    ) {
      updatedState.onSiteReasonList = data.onSiteReasonList;
    }

    if (
      Array.isArray(data?.onSiteEndReasonList) &&
      data.onSiteEndReasonList.length > 0
    ) {
      updatedState.onSiteEndReasonList = data.onSiteEndReasonList;
    }

    if (
      Array.isArray(data?.onRegularizeReasonList) &&
      data.onRegularizeReasonList.length > 0
    ) {
      updatedState.regularizeReasonList = data.onRegularizeReasonList;
    }

    if (
      Array.isArray(data?.onPermissionReasonList) &&
      data.onPermissionReasonList.length > 0
    ) {
      updatedState.permissionReasonList = data.onPermissionReasonList;
    }

    if (
      Array.isArray(data?.onLateReasonList) &&
      data.onLateReasonList.length > 0
    ) {
      updatedState.lateReasonList = data.onLateReasonList;
    }

    if (
      Array.isArray(data?.onEarlyCheckOutReasonList) &&
      data.onEarlyCheckOutReasonList.length > 0
    ) {
      updatedState.earlyCheckOutReasonList = data.onEarlyCheckOutReasonList;
    }

    if (Array.isArray(data?.approvalList) && data.approvalList.length > 0) {
      const newArr = [];

      data.approvalList.map((v) => {
        if (v.skipStep == "0") {
          newArr.push({
            staffId: v.staffId,
            assigneeName: v.assignName,
            roleId: v.roleId,
            isSkipStep: false,
            skipStep: v.skipStep,
          });
        } else {
          newArr.push({
            staffId: v.staffId,
            assigneeName: v.assignName,
            roleId: v.roleId,
            isSkipStep: true,
            skipStep: v.skipStep,
          });
        }
      });

      if (newArr) {
        updatedState.approvalSettings = newArr;
      }
    }
    setState(updatedState);
    dispatch(initCommonState());
  }, [updateData]);

  const handleLeavesChange = (e) => {
    setSaveLeaves({
      ...saveLeaves,
      list: e,
    });
    setState({
      ...state,
      moduleError: false,
    });
  };

  const handleRegularizeChange = (e) => {
    const {
      target: { name, checked },
    } = e;
    setState({
      ...state,
      isEnableRegularizeSettings: checked ? 1 : 0,
    });
  };

  const getModuleData = () => {
    let url = `${getAttendanceModulePath}${user.user_id}`;
    dispatch(commonGetDataTwo(url));
  };
  useEffect(() => {
    getModuleData();
  }, []);

  const mainHandleChange = (e) => {
    const {
      target: { name, value },
    } = e;
    if (name === "offSitePermissionEnable") {
      setState({
        ...state,
        offSitePermissionEnable: e.target.checked ? "1" : "0",
      });
    } else {
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const mainHandleChecked = (event) => {
    const {
      target: { name, checked },
    } = event;

    if (name === "isLogout") {
      if (!checked) {
        setState({
          ...state,
          offSiteEnable: "",
        });
      }
    }

    setState({
      ...state,
      [name]: checked ? 1 : 0,
    });
  };

  const beforeSubmitSettingData = () => {
    const elm = document.getElementById("submit-module");
    if (elm) {
      elm.click();
    }
  };

  const submitSettingData = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      let data = {
        path: "admin/attendanceGeneralSettings",
        data: {
          userId: user.user_id,
          moduleId: state.moduleId,
          moduleName: state.moduleName,
          employeeLocation: state.employeeLocation,
          regularizeAttendDays: state.regularizeAttendDays,
          regularizeAttendYear: state.regularizeAttendYear,
          reasonForPermission: state.reasonForPermission,
          reqularizeUpto: state.reqularizeUpto,
          reasonForLate: state.reasonForLate,
          permissionAvailDays: state.permissionAvailDays,
          permissionAvailYears: state.permissionAvailYears,
          reasonForPermission: state.reasonForPermission,
          lateArrivalMinutes: state.lateArrivalMinutes,
          reasonForLate: state.reasonForLate,
          earlyCheckoutMinutes: state.earlyCheckoutMinutes,
          reasonForEarly: state.reasonForEarly,
          mandatoryApprovalRequest: state.mandatoryApprovalRequest,
          mandatoryApprovalYears: state.mandatoryApprovalYears,
          gracePeriodHours: state.gracePeriodHours,
          allowEmpRegAfterClockOut: state.allowEmpRegAfterClockOut,
          enableOvertimePolicy: state.enableOvertimePolicy,
          offSitePermissions: state.offSitePermissions,
          offSitePermissionEnable: state.offSitePermissionEnable,
          isEnableRegularizeSettings: state.isEnableRegularizeSettings,
          empRequestRegularize: state.empRequestRegularize,
          regularizePeriodMax: state.regularizePeriodMax,
          regularizeAttendDays: state.regularizeAttendDays,
          regularizeAttendDate: state.regularizeAttendDate,
          exceedRegularizeRequest: state.exceedRegularizeRequest,
          orderOfLeaveRequest: saveLeaves.list
            .map((v) => {
              return v.value;
            })
            .toString(),
          isFaceEnable: state.isFaceEnable,
          isLocationEnable: state.isLocationEnable,
          autoClockOut: state.autoClockOut,
          offSiteEnable: state.offSiteEnable,
          isEnableBranchGeoFence: state.isLogout,
          onSiteReasonList: state.onSiteReasonList,
          onSiteEndReasonList: state.onSiteEndReasonList,
          regularizeReasonList: state.regularizeReasonList,
          permissionReasonList: state.permissionReasonList,
          lateReasonList: state.lateReasonList,
          earlyCheckOutReasonList: state.earlyCheckOutReasonList,
          trackLocationTime: state.trackLocationTime,
          reasonForPermission: state.reasonForPermission,
          allowHalfDays: state.allowHalfDays,
          allowHalfDaysYears: state.allowHalfDaysYears,
          approvalSettings: state.approvalSettings,
          rmLevels: {
            rmL1Days: state.l1Days,
            rmL1Approve: state.l1IsAutoPassApproval, // 1 - Auto approve 2- pass
            rmL2Days: state.l2Days,
            rmL2Approve: state.l2IsAutoPassApproval,
            rmL3Days: state.l3Days,
            rmL3Approve: state.l3IsAutoPassApproval,
          },
        },
      };
      dispatch(saveMoreSettingsOne(data));
    }
  };

  useEffect(() => {
    if (store.umSetSuccess) {
      toast.success(store.umSetMessage);
      dispatch(initMoreSettState());
    }
    if (store.umSetError) {
      toast.error(store.umSetMessage);
      dispatch(initMoreSettState());
    }
  }, [store.umSetSuccess, store.umSetError]);

  const [updateValue, setUpdateValue] = useState("1");

  const handleUpdateChange = (event, newValue) => {
    setUpdateValue(newValue);
  };

  const handleIsUpdated = () => {
    setUpdateValue("1")
    setIsUpdate(false);
    setState((preState) => ({
      ...preState,
      userId: user.user_id,
      moduleId: "",
      moduleName: "",
      employeeLocation: "",
      regularizeAttendDays: "",
      regularizeAttendYear: "",
      reasonForPermission: "",
      reqularizeUpto: "",
      reasonForLate: "",
      permissionAvailDays: "",
      permissionAvailYears: "",
      reasonForPermission: "",
      lateArrivalMinutes: "",
      reasonForLate: "",
      earlyCheckoutMinutes: "",
      reasonForEarly: "",
      mandatoryApprovalRequest: "",
      mandatoryApprovalYears: "",
      gracePeriodHours: "",
      allowEmpRegAfterClockOut: "",
      enableOvertimePolicy: "",
      offSitePermissions: "",
      offSitePermissionEnable: "",
      isEnableRegularizeSettings: "",
      empRequestRegularize: "",
      regularizePeriodMax: "",
      regularizeAttendDays: "",
      regularizeAttendDate: "",
      exceedRegularizeRequest: "",
      orderOfLeaveRequest: "",
      isFaceEnable: "",
      isLocationEnable: "",
      offSitePermissions3: "",
      isLogout: "",
      autoClockOut: "",
      offSiteEnable: "",
      isEnableBranchGeoFence: "",
      annualLeave: "",
      onSiteReasonList: [
        {
          reasonName: "",
        },
      ],
      onSiteEndReasonList: [
        {
          reasonName: "",
        },
      ],
      regularizeReasonList: [
        {
          reasonName: "",
        },
      ],
      permissionReasonList: [
        {
          reasonName: "",
        },
      ],
      lateReasonList: [
        {
          reasonName: "",
        },
      ],
      earlyCheckOutReasonList: [
        {
          reasonName: "",
        },
      ],
      trackLocationTime: "",
      reasonForPermission: "",
      allowHalfDays: "",
      allowHalfDaysYears: "",
      approvalSettings: [
        {
          staffId: "",
          assigneeName: "",
          roleId: "",
          isSkipStep: false,
          skipStep: 0,
        },
      ],
      moduleError: false,
      approveDays: "",

      l1Days: "",
      l1IsAutoPassApproval: "0",

      l2Days: "",
      l2IsAutoPassApproval: "0",

      l3Days: "",
      l3IsAutoPassApproval: "0",
    }));
  };

  const theme = localStorage.getItem("theme")

  return (
    <>
      <Dialog
        open={isUpdate}
        onClose={handleIsUpdated}
        fullWidth={true}
        maxWidth={"lg"}
        style={{ overflow: "visible" }}
        className="dark-bg-color"
      >
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleIsUpdated}>
              X
            </span>
            <span className="title">Update Attendance Module</span>
          </div>
          <button className="universal-btn" onClick={submitSettingData}>
            Update
          </button>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={updateValue}>
              {/* MODULE NAME SECTION - ABOVE TABS */}
              <Box sx={{
                marginBottom: "10px",
                paddingBottom: "10px",
                borderBottom: theme === "light" ? "1px solid #e0e0e0" : "1px solid #444"
              }}>
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={submitSettingData}
                >
                  <Form.Group style={{ margin: 0 }}>
                    <Form.Label
                      style={{
                        color: theme === "light" ? "#333" : "#ffffff",
                        fontWeight: "600",
                        marginBottom: "8px",
                        display: "block",
                        textAlign: "left",
                        fontSize: "16px"
                      }}
                    >
                    </Form.Label>
                    <Form.Control
                      name="moduleName"
                      value={state.moduleName}
                      onChange={mainHandleChange}
                      placeholder="Enter module name"
                      required
                      style={{
                        backgroundColor: theme === "light" ? "#c2c5c8c4" : "#1906285d",
                        border: theme === "light" ? "1px solid #ddd" : "1px solid #444",
                        borderRadius: "8px",
                        padding: "10px 15px",
                        textAlign: "left",
                        width: "100%",
                        maxWidth: "300px",
                        color: theme === "light" ? "#333" : "#ffffff85",
                        fontSize: "14px"
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Module name is required
                    </Form.Control.Feedback>
                  </Form.Group>
                  <button
                    type="submit"
                    id="submit-module"
                    style={{ display: "none" }}
                  ></button>
                </Form>
              </Box>

              {/* TABS SECTION */}
              <Box sx={{ borderBottom: "1px solid gray", marginBottom: "10px" }}>
                <TabList
                  onChange={handleUpdateChange}
                  aria-label="lab API tabs example"
                  textColor="inherit"
                  indicatorColor="none"
                  sx={{
                    "& .MuiTab-root": {
                      color: theme == "light" ?
                        "#000" : "#fff !important",
                      fontWeight: "500",
                      fontSize: "14px",
                      textTransform: "none",
                      minHeight: "40px"
                    },
                    "& .Mui-selected": {
                      color: theme == "light" ?
                        "#313030ff" : "#8660F8 !important",
                      fontWeight: "600"
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: theme == "light" ?
                        "#313030ff !important" : "#8660F8 !important",
                      height: "3px"
                    },
                  }}
                >
               <Tab label="General Setting" value="1" />
                <Tab label="Regularization" value="2" />
                <Tab label="Permission Settings" value="3" />
                <Tab label="Approval Chain" value="4" />
                </TabList>
              </Box>

              {/* TAB PANELS */}
              <TabPanel value="1" sx={{ padding: 0 }}>
                <Box sx={{
                  width: "100%",
                  margin: "0"
                }}>
                  <UpdateGeneralSetting
                    mainHandleChange={mainHandleChange}
                    mainHandleChecked={mainHandleChecked}
                    setMainTabIndex={setMainTabIndex}
                    mainState={state}
                    setMainState={setState}
                    setUpdateValue={setUpdateValue}
                  />
                </Box>
              </TabPanel>

              <TabPanel value="2" sx={{ padding: 0 }}>
                <Box sx={{
                  width: "100%",
                  margin: "0"
                }}>
                  <UpdateAttendanceRegularization
                    attendOptions={attendOptions}
                    mainHandleChange={mainHandleChange}
                    mainState={state}
                    setMainTabIndex={setMainTabIndex}
                    setMainState={setState}
                    handleRegularizeChange={handleRegularizeChange}
                    handleLeavesChange={handleLeavesChange}
                    saveLeaves={saveLeaves}
                    setSaveLeaves={setSaveLeaves}
                    setUpdateValue={setUpdateValue}
                  />
                </Box>
              </TabPanel>

              <TabPanel value="3" sx={{ padding: 0 }}>
                <Box sx={{
                  width: "100%",
                  margin: "0"
                }}>
                  <UpdateLateCheckInEarlyCheckOut
                    attendOptions={attendOptions}
                    mainHandleChange={mainHandleChange}
                    mainState={state}
                    setMainTabIndex={setMainTabIndex}
                    setMainState={setState}
                    setUpdateValue={setUpdateValue}
                  />
                </Box>
              </TabPanel>

              <TabPanel value="4" sx={{ padding: 0 }}>
                <Box sx={{
                  width: "100%",
                  margin: "0"
                }}>
                  <UpdateApprovalChain
                    attendOptions={attendOptions}
                    mainHandleChange={mainHandleChange}
                    setMainTabIndex={setMainTabIndex}
                    mainState={state}
                    setMainState={setState}
                    setUpdateValue={setUpdateValue}
                  />
                </Box>
              </TabPanel>
             
            </TabContext>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

const UpdateGeneralSetting = ({
  mainHandleChange,
  mainHandleChecked,
  setMainTabIndex,
  mainState,
  setMainState,
  setUpdateValue,
}) => {
  const addOnSiteReason = () => {
    const newArr = [...mainState.onSiteReasonList];
    newArr.push({ reasonName: "" });
    setMainState({
      ...mainState,
      onSiteReasonList: newArr,
    });

  };

  const removeOnSiteReason = (idx) => {
    const newArr = [...mainState.onSiteReasonList];
    newArr.splice(idx, 1);
    setMainState({
      ...mainState,
      onSiteReasonList: newArr,
    });
  };

  const handleOnSiteReason = (e, idx) => {
    const {
      target: { name, value },
    } = e;

    const newArr = mainState.onSiteReasonList.map((item, i) =>
      i === idx ? { ...item, [name]: value } : item
    );

    setMainState({
      ...mainState,
      onSiteReasonList: newArr,
    });
  };

  const addOnSiteEndReason = () => {
    const newReason = { reasonName: "" };
    setMainState((prevState) => ({
      ...prevState,
      onSiteEndReasonList: [newReason, ...prevState.onSiteEndReasonList], // Add to the beginning of the array
    }));
  };

  const removeOnSiteEndReason = (idx) => {
    const newArr = [...mainState.onSiteEndReasonList];
    newArr.splice(idx, 1);
    setMainState({
      ...mainState,
      onSiteEndReasonList: newArr,
    });
  };

  const handleOnSiteEndReason = (e, idx) => {
    const {
      target: { value, name },
    } = e;

    const newArr = mainState.onSiteEndReasonList.map((item, i) =>
      i === idx ? { ...item, [name]: value } : item
    );

    setMainState({
      ...mainState,
      onSiteEndReasonList: newArr,
    });
  };

  const submitHandle = (e) => {
    e.preventDefault();
  };

  const handleRadioBtn = (e) => {
    const { value } = e.target;
    setMainState({
      ...mainState,
      offSitePermissions: value,
    });
  };

  return (
    <div
      className="more-setting-form-container"
      style={{ backgroundColor: "transparent" }}
    >
      <Form
        className="form"
        onSubmit={submitHandle}
        style={{ padding: "0 10px", paddingBottom: "30px" }}
      >
        <Form.Group className="mb-4  border-black">
          <Row>
            <Col sm="12" className="flex-form universal-bg-color transparent-bg">
              <div style={{ cursor: "default", backgroundColor: "transparent" }} className="transparent-bg">
                <b>
                  Mark Attendance form
                </b>
                <div className="MarkAttendanceform-radio-card transparent-bg" style={{ background: "red" }}>
                  <div className="MarkAttendanceform-radio">
                    <input
                      name="employeeLocation"
                      type="radio"
                      value="1"
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      checked={
                        mainState.employeeLocation == "1" ? "checked" : null
                      }
                    />
                    <label>Only in Assigned Location</label>
                  </div>
                  <div className="MarkAttendanceform-radio">
                    <input
                      name="employeeLocation"
                      type="radio"
                      value="2"
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      checked={
                        mainState.employeeLocation == "2" ? "checked" : null
                      }
                    />
                    <label>From Anywhere</label>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <label>Enable AI Face Recognition Setting &nbsp;</label>
              <Switch
                name="isFaceEnable"
                checked={mainState.isFaceEnable == "1" ? true : false}
                onChange={(e) => {
                  mainHandleChecked(e);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <label>Track Location Permission &nbsp;</label>
              <Switch
                name="isLocationEnable"
                checked={mainState.isLocationEnable == "1" ? true : false}
                onChange={(e) => {
                  mainHandleChecked(e);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col sm={12} className="flex-form mb-3 universal-bg-color">
              <label>Track Location Every &nbsp;</label>
              <Form.Control
                name="trackLocationTime"
                value={mainState.trackLocationTime}
                onChange={(e) => {
                  mainHandleChange(e);
                }}
                style={{ width: "200px" }}
                placeholder="Enter minutes"
                className="universal-input"
              />
              <label> &nbsp;&nbsp;Minutes</label>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className=" mb-3"
              style={{
                border: "1px solid lightgray",
                borderRadius: "7px",
                padding: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <label className="color-white">
                  Enable Auto Clock-Out &nbsp;
                </label>
                <Switch
                  name="autoClockOut"
                  checked={mainState.autoClockOut == "1" ? true : false}
                  onChange={(e) => {
                    mainHandleChecked(e);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>

              <span
                style={{
                  position: "relative",
                  marginTop: "10px",
                  fontSize: "14px",
                  color: "gray",
                }}
              >
                Automatically clock out employees if they fail to clock out
                after their shift ends.
              </span>
            </Col>
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        {mainState.autoClockOut == "1" && (
          <div
            className={
              mainState.autoClockOut == "1"
                ? "drop-container"
                : "container-hide"
            }
          >
            <Form.Group>
              <Row>
                <Col
                  sm={12}
                  className="mb-3"
                  style={{
                    // border: "1px solid lightgray",
                    // borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Grace Period (in hours) &nbsp;
                    </label>
                    <Form.Control
                      name="gracePeriodHours"
                      placeholder="Enter number of hours (e.g., 2)"
                      onChange={mainHandleChange}
                      value={mainState.gracePeriodHours}
                      className="universal-input"
                    />
                  </div>
                  <span
                    style={{
                      position: "relative",
                      top: "5px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Specify the number of hours after shift end for auto
                    clock-out to activate.
                  </span>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Field is required
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Row>
                <Col
                  sm={12}
                  className=" mb-3"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="color-white">
                      Allow Employees to Regularize Attendance After Auto
                      Clock-Out &nbsp;
                    </label>
                    <Switch
                      name="allowEmpRegAfterClockOut"
                      checked={
                        mainState.allowEmpRegAfterClockOut == "1" ? true : false
                      }
                      onChange={(e) => {
                        mainHandleChecked(e);
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                  <span
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Do Not Allow Regularization After Auto Clock-Out.
                  </span>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Field is required
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Row>
                <Col
                  sm={12}
                  className=" mb-3"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="color-white">
                      Enable Overtime Policy Exception &nbsp;
                    </label>
                    <Switch
                      name="enableOvertimePolicy"
                      checked={
                        mainState.enableOvertimePolicy == "1" ? true : false
                      }
                      onChange={(e) => {
                        mainHandleChecked(e);
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                  <span
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Exclude employees with assigned overtime policies from Auto
                    Clock-Out.
                  </span>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Field is required
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        )}

        <Form.Group>
          <Row>
            <Col
              sm="12"
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <label className="color-white">
                Logout When the employee moves out of the Branch Geo
                Fencing&nbsp;
              </label>
              <Switch
                name="isLogout"
                checked={mainState.isLogout == "1"} //mainState.isEnableBranchGeoFence == 1 ? true : false
                onChange={(e) => {
                  mainHandleChecked(e);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
        </Form.Group>

        {mainState.isLogout == "1" && (
          <Form.Group>
            <Row>
              <Col
                sm={12}
                className="flex-form mb-3 universal-bg-color"
                style={{ justifyContent: "space-between" }}
              >
                <label className="color-white">Enable Off Site &nbsp;</label>
                <Switch
                  name="offSiteEnable"
                  checked={mainState.offSiteEnable == "1" ? true : false}
                  onChange={(e) => {
                    mainHandleChecked(e);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Col>
            </Row>
            <Form.Control.Feedback type={"invalid"}>
              Field is required
            </Form.Control.Feedback>
          </Form.Group>
        )}

        {mainState.isLogout == "1" && mainState.offSiteEnable == 1 && (
          <div
            className={
              mainState.offSiteEnable == 1 ? "drop-container" : "container-hide"
            }
          >
            {mainState.onSiteReasonList.map((row, idx) => {
              return (
                <Form.Group key={`onSiteReason-${idx}`}>
                  <Row>
                    <Col
                      sm={12}
                      className="flex-form mb-3 universal-bg-color"
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handleOnSiteReason(e, idx);
                          }}
                          placeholder="On site start reason"
                          required
                          className="universal-input"
                        />

                        {idx === 0 && (
                          <FaRegSquarePlus
                            onClick={addOnSiteReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx !== 0 && (
                          <FiMinusSquare
                            onClick={() => removeOnSiteReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}

            <Form.Group key={0}>
              <Row>
                <Col sm={12} className="flex-form mb-3 universal-bg-color">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <Form.Control
                      name="reasonName"
                      value={mainState.onSiteReasonList[0].reasonName}
                      onChange={(e) => {
                        handleOnSiteReason(e, 0);
                      }}
                      placeholder="On site start reason"
                      required
                      className="universal-input"
                    />

                    <FaRegSquarePlus
                      onClick={addOnSiteReason}
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "skyblue",
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Reason is required.
              </Form.Control.Feedback>
            </Form.Group>


            {mainState.onSiteEndReasonList.map((row, idx) => {
              return (
                <Form.Group key={`onSiteEndReason-${idx}`}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handleOnSiteEndReason(e, idx);
                          }}
                          placeholder="On site end reason"
                          required
                          className="universal-input"
                        />

                        {idx === 0 && (
                          <FaRegSquarePlus
                            onClick={addOnSiteEndReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx !== 0 && (
                          <FiMinusSquare
                            onClick={() => removeOnSiteEndReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}



            <Form.Group key={0}>
              <Row>
                <Col sm={12} className="flex-form mb-3 universal-bg-color">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <Form.Control
                      name="reasonName"
                      value={mainState.onSiteEndReasonList[0].reasonName}
                      onChange={(e) => {
                        handleOnSiteEndReason(e, 0);
                      }}
                      placeholder="On site end reason"
                      required
                      className="universal-input"
                    />

                    <FaRegSquarePlus
                      onClick={addOnSiteEndReason}
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "skyblue",
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Form.Control.Feedback type={"invalid"}>
                Reason is required.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  gap: "10px",
                }}
              >
                <Form.Check
                  type="radio"
                  name="offSitePermissions"
                  id="offSitePermissions1"
                  value={"1"}
                  label={
                    <label
                      style={{ cursor: "pointer" }}
                      className="color-white"
                      htmlFor="offSitePermissions1"
                    >
                      Require employees to return to the office to log out.
                    </label>
                  }
                  onChange={handleRadioBtn}
                  checked={mainState.offSitePermissions == "1" ? true : false}
                />
                <Form.Check
                  type="radio"
                  name="offSitePermissions"
                  id="offSitePermissions2"
                  value={"2"}
                  label={
                    <label
                      style={{ cursor: "pointer" }}
                      className="color-white"
                      htmlFor="offSitePermissions2"
                    >
                      Allow employees to log out from any location.
                    </label>
                  }
                  onChange={handleRadioBtn}
                  checked={mainState.offSitePermissions == "2" ? true : false}
                />
              </div>

              <br />
              <br />
              <div
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "7px",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <label className="color-white">
                    Mandatory Approval for Off Site Requests &nbsp;
                  </label>
                  <Switch
                    name="offSitePermissions3"
                    checked={
                      mainState.offSitePermissions3 == 1 ? "checked" : null
                    }
                    onChange={(e) => {
                      mainHandleChecked(e);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                <span
                  style={{
                    position: "relative",
                    fontSize: "13px",
                    color: "gray",
                  }}
                >
                  All Off Site requests will require manager approval. Managers
                  must approve or reject each request based on tracked details.
                </span>
              </div>
              <br />

              {mainState.offSitePermissions3 == "1" && (
                <>
                  <span
                    style={{
                      marginTop: "20px",
                      fontSize: "13px",
                      color: "gray",
                    }}
                  >
                    If this option is disabled, the system will not deduct any
                    hours or apply LOP for Off Site requests, and they will be
                    automatically approved without manager intervention.
                  </span>
                  <Form.Check
                    name="offSitePermissionEnable"
                    onChange={mainHandleChange}
                    defaultChecked={
                      mainState.offSitePermissionEnable == "1"
                        ? "checked"
                        : null
                    }
                    label="Yes / No"
                    className="color-white"
                  />
                  <span
                    style={{
                      marginTop: "20px",
                      fontSize: "13px",
                      color: "gray",
                    }}
                  >
                    Note: Disabling this feature means employees on Off Site
                    will not be subject to attendance or leave deductions
                    regardless of their geofence activity.
                  </span>
                </>
              )}
            </Form.Group>
          </div>
        )}

        <Form.Group>
          <Row>
            <Col
              sm={12}
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <label className="color-white">
                <MdFingerprint /> Biometric Attendance &nbsp;
              </label>
              <Switch
                checked={false}
                onChange={() => {
                  mainHandleChange;
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Col>
          </Row>
        </Form.Group>

        <Row>
          <Col
            sm="12"
            style={{
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <CustomButton
              type={"button"}
              class_name="p_btn universal-input-one"
              text={"Next"}
              url_or_onclick={() => setUpdateValue("2")}
              icon={null}
              width="150px"
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

const UpdateAttendanceRegularization = ({
  attendOptions,
  mainHandleChange,
  mainState,
  setMainTabIndex,
  setMainState,
  handleRegularizeChange,
  handleLeavesChange,
  saveLeaves,
  setSaveLeaves,
  setUpdateValue,
}) => {
  const [user] = useState(JSON.parse(localStorage.getItem("user_data")));
  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);

  const [selectedLeaves, setSelectedLeaves] = useState([]);
  const [leaveList, setLeaveList] = useState([]);

  const addRegularizePermissionReason = () => {
    const newArr = [...mainState.regularizeReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, regularizeReasonList: newArr });
  };

  const removeRegularizePermissionReason = (index) => {
    const newArr = [...mainState.regularizeReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, regularizeReasonList: newArr });
  };

  const handleRegularizePermission = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.regularizeReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, regularizeReasonList: newArr });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const getLeaveList = useCallback(() => {
    let path = `${fetchLeavePath}${user.user_id}`;
    dispatch(commonGetDataOne(path));
  }, []);

  useEffect(() => {
    getLeaveList();
  }, []);

  useEffect(() => {
    if (commonStore.commonGetOneSuccess) {
      if (
        Array.isArray(commonStore.commonGetOneData) &&
        commonStore.commonGetOneData.length > 0
      ) {
        const listArray = commonStore.commonGetOneData.map((val) => {
          return {
            label: val.leaveName,
            value: val.leaveId,
          };
        });
        setLeaveList(listArray);
        const dateArray = mainState.orderOfLeaveRequest.split(",");
        if (Array.isArray(dateArray)) {
          const selected = dateArray
            .map((v) =>
              listArray.find((obj) => parseInt(obj.value) === parseInt(v))
            )
            .filter(Boolean);
          setSaveLeaves({ ...saveLeaves, list: selected });
          setSelectedLeaves(selected);
        }
      }
    }
  }, [commonStore.commonGetOneSuccess]);

  return (
    <div
      className="more-setting-form-container"
      style={{ backgroundColor: "transparent" }}
    >
      <Form className="form" onSubmit={handleSubmit}>
        <Form.Group>
          <Row>
            <Form.Label className="color-white">
              Regularization Policy Settings
            </Form.Label>

            <Col
              sm="12"
              className="flex-form mb-3 universal-bg-color"
              style={{ justifyContent: "space-between" }}
            >
              <span>
                Allow employees to regularise attendance when discrepancies
                occur
              </span>

              <Switch
                label="Check"
                checked={
                  mainState.isEnableRegularizeSettings == "1" ? true : false
                }
                onChange={handleRegularizeChange}
              />
            </Col>

            {mainState.isEnableRegularizeSettings == 1 && (
              <div
                className={
                  mainState.isEnableRegularizeSettings == 1
                    ? "drop-container"
                    : null
                }
              >
                <Col
                  sm={12}
                  className="mb-3"
                  style={{
                    // border: "1px solid lightgray",
                    // borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">
                      Select how often employees can request regularization.
                      &nbsp;
                    </label>
                    &nbsp;&nbsp;
                    <Form.Select
                      name="empRequestRegularize"
                      value={mainState.empRequestRegularize}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      style={{ width: "270px" }}
                      className="universal-input"
                    >
                      <option value="">Select an option</option>
                      {attendOptions.map((row, idx) => {
                        return (
                          <option value={row.id} key={idx}>
                            {row.options}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </div>
                </Col>

                <Col
                  sm="12"
                  style={{
                    // border: "1px solid lightgray",
                    // borderRadius: "7px",
                    padding: "10px",
                  }}
                  className="mb-3"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Specify the maximum number of regularization requests
                      allowed within the selected period &nbsp;
                    </label>
                    <Form.Control
                      style={{ width: "100%" }}
                      placeholder="Enter here"
                      name="regularizePeriodMax"
                      value={mainState.regularizePeriodMax}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="universal-input"
                    />
                  </div>
                </Col>

                {mainState.regularizePeriodMax &&
                  mainState.regularizeReasonList.map((row, idx) => {
                    return (
                      <Form.Group key={idx}>
                        <Row style={{ padding: "0 10px" }}>
                          <Col
                            sm={12}
                            className="flex-form mb-3 universal-bg-color"
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "start",
                                gap: "10px",
                              }}
                            >
                              <Form.Control
                                name="reasonName"
                                value={row.reasonName}
                                onChange={(e) => {
                                  handleRegularizePermission(e, idx);
                                }}
                                placeholder="Reason for regularize"
                                required
                                className="universal-input"
                              />
                              {idx == 0 && (
                                <FaRegSquarePlus
                                  onClick={addRegularizePermissionReason}
                                  style={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "skyblue",
                                  }}
                                />
                              )}
                              {idx != 0 && (
                                <FiMinusSquare
                                  onClick={() =>
                                    removeRegularizePermissionReason(idx)
                                  }
                                  style={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                />
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Form.Control.Feedback type={"invalid"}>
                          Reason for permission is required.
                        </Form.Control.Feedback>
                      </Form.Group>
                    );
                  })}

                <Col
                  sm="12"
                  style={{
                    // border: "1px solid lightgray",
                    // borderRadius: "7px",
                    padding: "10px",
                  }}
                  className="mb-3"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Apply Regularisation Within &nbsp;
                    </label>
                    <Form.Control
                      style={{ width: "100%" }}
                      placeholder="Enter here"
                      name="regularizeAttendDays"
                      value={mainState.regularizeAttendDays}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="universal-input"
                    />
                    <label style={{ textWrap: "nowrap" }} className="color-white">
                      Days &nbsp;
                    </label>
                  </div>

                  <br />
                  <center className="color-white">OR</center>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">
                      Set a deadline for submitting regularization requests
                      after an attendance discrepancy is identified. &nbsp;
                    </label>
                    &nbsp;&nbsp;
                    <Form.Select
                      name="regularizeAttendDate"
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      style={{ width: "170px" }}
                      className="universal-input"
                    >
                      <option value="" key={0}>
                        Select Date
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "1"
                            ? "selected"
                            : false
                        }
                        value="1"
                        key={1}
                      >
                        1
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "2"
                            ? "selected"
                            : false
                        }
                        value="2"
                        key={2}
                      >
                        2
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "3"
                            ? "selected"
                            : false
                        }
                        value="3"
                        key={3}
                      >
                        3
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "4"
                            ? "selected"
                            : false
                        }
                        value="4"
                        key={4}
                      >
                        4
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "5"
                            ? "selected"
                            : false
                        }
                        value="5"
                        key={5}
                      >
                        5
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "6"
                            ? "selected"
                            : false
                        }
                        value="6"
                        key={6}
                      >
                        6
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "7"
                            ? "selected"
                            : false
                        }
                        value="7"
                        key={7}
                      >
                        7
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "8"
                            ? "selected"
                            : false
                        }
                        value="8"
                        key={8}
                      >
                        8
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "9"
                            ? "selected"
                            : false
                        }
                        value="9"
                        key={9}
                      >
                        9
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "10"
                            ? "selected"
                            : false
                        }
                        value="10"
                        key={10}
                      >
                        10
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "11"
                            ? "selected"
                            : false
                        }
                        value="11"
                        key={11}
                      >
                        11
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "12"
                            ? "selected"
                            : false
                        }
                        value="12"
                        key={12}
                      >
                        12
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "13"
                            ? "selected"
                            : false
                        }
                        value="13"
                        key={13}
                      >
                        13
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "14"
                            ? "selected"
                            : false
                        }
                        value="14"
                        key={14}
                      >
                        14
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "15"
                            ? "selected"
                            : false
                        }
                        value="15"
                        key={15}
                      >
                        15
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "16"
                            ? "selected"
                            : false
                        }
                        value="16"
                        key={16}
                      >
                        16
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "17"
                            ? "selected"
                            : false
                        }
                        value="17"
                        key={17}
                      >
                        17
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "18"
                            ? "selected"
                            : false
                        }
                        value="18"
                        key={18}
                      >
                        18
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "19"
                            ? "selected"
                            : false
                        }
                        value="19"
                        key={19}
                      >
                        19
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "20"
                            ? "selected"
                            : false
                        }
                        value="20"
                        key={20}
                      >
                        20
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "21"
                            ? "selected"
                            : false
                        }
                        value="21"
                        key={21}
                      >
                        21
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "22"
                            ? "selected"
                            : false
                        }
                        value="22"
                        key={22}
                      >
                        22
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "23"
                            ? "selected"
                            : false
                        }
                        value="23"
                        key={23}
                      >
                        23
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "24"
                            ? "selected"
                            : false
                        }
                        value="24"
                        key={24}
                      >
                        24
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "25"
                            ? "selected"
                            : false
                        }
                        value="25"
                        key={25}
                      >
                        25
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "26"
                            ? "selected"
                            : false
                        }
                        value="26"
                        key={26}
                      >
                        26
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "27"
                            ? "selected"
                            : false
                        }
                        value="27"
                        key={27}
                      >
                        27
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "28"
                            ? "selected"
                            : false
                        }
                        value="28"
                        key={28}
                      >
                        28
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "29"
                            ? "selected"
                            : false
                        }
                        value="29"
                        key={29}
                      >
                        29
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "30"
                            ? "selected"
                            : false
                        }
                        value="30"
                        key={30}
                      >
                        30
                      </option>
                      <option
                        selected={
                          mainState.regularizeAttendDate == "31"
                            ? "selected"
                            : false
                        }
                        value="31"
                        key={31}
                      >
                        31 {mainState.regularizeAttendDate}
                      </option>
                    </Form.Select>
                  </div>
                </Col>

                <Col
                  sm={12}
                  className="mb-3"
                  style={{
                    // border: "1px solid lightgray",
                    // borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">
                      Action for Exceeding Regularisation Requests&nbsp;
                    </label>
                    &nbsp;&nbsp;
                    <Form.Select
                      name="exceedRegularizeRequest"
                      value={mainState.exceedRegularizeRequest}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      style={{ width: "270px" }}
                      className="universal-input"
                    >
                      <option value="" key={0}>
                        Select an option
                      </option>
                      <option value="1" key={1}>
                        Require Special Permission
                      </option>
                      <option value="2" key={2}>
                        Mark as Leave Without Pay (LOP)
                      </option>
                      <option value="3" key={3}>
                        Deduct from Leave Balance
                      </option>
                    </Form.Select>
                  </div>
                </Col>

                {mainState.exceedRegularizeRequest == 3 && (
                  <Col
                    sm={12}
                    className="mb-3"
                    style={{
                      border: "1px solid lightgray",
                      borderRadius: "7px",
                      padding: "20px 10px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        gap: "10px",
                        border: mainState.moduleError && "1px solid red",
                      }}
                    >
                      <label style={{ textWrap: "nowrap" }} className="color-white">
                        Select the order of leave deduction if regularisation{" "}
                        <br />
                        requests exceed the allowed limit &nbsp;
                      </label>
                      &nbsp;&nbsp;
                      <MultiSelect
                        value={selectedLeaves}
                        labelledBy="Select Leaves"
                        options={leaveList}
                        onChange={(newValue) => {
                          setSelectedLeaves(newValue);
                          handleLeavesChange(newValue);
                        }}
                        className="custom-multi-select m-select"
                      />
                    </div>

                    <span
                      style={{
                        position: "relative",
                        marginTop: "10px",
                        fontSize: "14px",
                        color: "gray",
                      }}
                    ></span>
                  </Col>
                )}
              </div>
            )}
          </Row>
          <Form.Control.Feedback type={"invalid"}>
            Field is required
          </Form.Control.Feedback>
        </Form.Group>

        <Row>
          <Col
            sm="12"
            style={{
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <CustomButton
              type={"button"}
              class_name="p_btn universal-input-one"
              text={"Back"}
              url_or_onclick={() => setUpdateValue("1")}
              icon={null}
              width="150px"
            />

            <CustomButton
              type={"button"}
              class_name="p_btn universal-input-one"
              text={"Next"}
              url_or_onclick={() => setUpdateValue("3")}
              icon={null}
              width="150px"
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

const UpdateLateCheckInEarlyCheckOut = ({
  attendOptions,
  mainHandleChange,
  mainState,
  setMainTabIndex,
  setMainState,
  setUpdateValue,
}) => {
  const addPermissionReason = () => {
    const newArr = [...mainState.permissionReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, permissionReasonList: newArr });
  };

  const removePermissionReason = (index) => {
    const newArr = [...mainState.permissionReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, permissionReasonList: newArr });
  };

  const handlePermission = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.permissionReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, permissionReasonList: newArr });
  };

  const addLateReason = () => {
    const newArr = [...mainState.lateReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, lateReasonList: newArr });
  };

  const removeLateReason = (index) => {
    const newArr = [...mainState.lateReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, lateReasonList: newArr });
  };

  const handleLateReason = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.lateReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, lateReasonList: newArr });
  };

  const addEarlyReason = () => {
    const newArr = [...mainState.earlyCheckOutReasonList];
    newArr.push({ reasonName: "" });
    setMainState({ ...mainState, earlyCheckOutReasonList: newArr });
  };

  const removeEarlyReason = (index) => {
    const newArr = [...mainState.earlyCheckOutReasonList];
    newArr.splice(index, 1);
    setMainState({ ...mainState, earlyCheckOutReasonList: newArr });
  };

  const handleEarlyReason = (e, index) => {
    const {
      target: { name, value },
    } = e;
    const newArr = [...mainState.earlyCheckOutReasonList];
    newArr[index][name] = value;
    setMainState({ ...mainState, earlyCheckOutReasonList: newArr });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <div
        className="more-setting-form-container"
        style={{ backgroundColor: "transparent" }}
      >
        <Form className="form" onSubmit={handleSubmit}>
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Permissions can be availed for &nbsp;</label>
                <Form.Control
                  name="permissionAvailDays"
                  value={mainState.permissionAvailDays}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  placeholder="ex:5"
                  style={{ width: "80px" }}
                  className="universal-input-one"
                />
                <label>&nbsp;&nbsp;days in a&nbsp;&nbsp;</label>
                <Form.Select
                  name="permissionAvailYears"
                  value={mainState.permissionAvailYears}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "170px" }}
                  className="universal-input-one"
                >
                  <option value="">Select an option</option>
                  {attendOptions.map((row, idx) => {
                    return (
                      <option value={row.id} key={idx}>
                        {row.options}
                      </option>
                    );
                  })}
                </Form.Select>
              </Col>
            </Row>
            <Form.Control.Feedback type={"invalid"}>
              Field is required
            </Form.Control.Feedback>
          </Form.Group>

          {mainState.permissionAvailDays != "" &&
            mainState.permissionAvailYears != "" &&
            mainState.permissionReasonList.map((row, idx) => {
              return (
                <Form.Group key={idx}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handlePermission(e, idx);
                          }}
                          placeholder="Reason for permission"
                          required
                          className="universal-input-one"
                        />
                        {idx == 0 && (
                          <FaRegSquarePlus
                            onClick={addPermissionReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx != 0 && (
                          <FiMinusSquare
                            onClick={() => removePermissionReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason for permission is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Late Arrival of &nbsp;</label>
                <Form.Control
                  name="lateArrivalMinutes"
                  value={mainState.lateArrivalMinutes}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "200px" }}
                  placeholder="Enter minutes"
                  className="universal-input-one"
                />
                <label>&nbsp; Minutes is allowed per request</label>
              </Col>
            </Row>
          </Form.Group>

          {mainState.lateArrivalMinutes != "" &&
            mainState.lateReasonList.map((row, idx) => {
              return (
                <Form.Group key={idx}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handleLateReason(e, idx);
                          }}
                          placeholder="Reason for Late"
                          required
                          className="universal-input-one"
                        />
                        {idx == 0 && (
                          <FaRegSquarePlus
                            onClick={addLateReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx != 0 && (
                          <FiMinusSquare
                            onClick={() => removeLateReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason for permission is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}

          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Early Check Out of &nbsp;</label>
                <Form.Control
                  name="earlyCheckoutMinutes"
                  value={mainState.earlyCheckoutMinutes}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "200px" }}
                  placeholder="Enter minutes"
                  className="universal-input-one"
                />
                <label>&nbsp; Minutes is allowed per request</label>
              </Col>
            </Row>
          </Form.Group>

          {mainState.earlyCheckoutMinutes != "" &&
            mainState.earlyCheckOutReasonList.map((row, idx) => {
              return (
                <Form.Group key={idx}>
                  <Row>
                    <Col sm={12} className="flex-form mb-3 universal-bg-color">
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          name="reasonName"
                          value={row.reasonName}
                          onChange={(e) => {
                            handleEarlyReason(e, idx);
                          }}
                          placeholder="Reason for Early"
                          required
                          className="universal-input-one"
                        />
                        {idx == 0 && (
                          <FaRegSquarePlus
                            onClick={addEarlyReason}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "skyblue",
                            }}
                          />
                        )}
                        {idx != 0 && (
                          <FiMinusSquare
                            onClick={() => removeEarlyReason(idx)}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Form.Control.Feedback type={"invalid"}>
                    Reason for permission is required.
                  </Form.Control.Feedback>
                </Form.Group>
              );
            })}

          <Row>
            <Col
              sm="12"
              style={{
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Back"}
                url_or_onclick={() => setUpdateValue("2")}
                icon={null}
                width="150px"
              />

              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Next"}
                url_or_onclick={() => setUpdateValue("4")}
                icon={null}
                width="150px"
              />
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

const UpdateApprovalChain = ({
  attendOptions,
  mainHandleChange,
  setMainTabIndex,
  mainState,
  setMainState,
  setUpdateValue,
}) => {
  const [user] = useState(JSON.parse(localStorage.getItem("user_data")));
  const dispatch = useDispatch();
  const empStore = useSelector((state) => state.employee);

  const [staffList, setStaffList] = useState([]);

  const getStaffList = useCallback(() => {
    const path = `${getEmployeeManageListPath}${user.user_id}`;
    dispatch(getEmployeeData(path));
  }, []);

  useEffect(() => {
    getStaffList();
  }, []);

  useEffect(() => {
    if (empStore.empGetSuccess) {
      setStaffList(empStore.empGetData);
      dispatch(initEmpState());
    }
  }, [empStore.empGetSuccess]);

  const addMoreAssignees = () => {
    const newAssignees = [...mainState.approvalSettings];
    newAssignees.push({
      staffId: "",
      assigneeName: "",
      roleId: "",
      isSkipStep: false,
      skipStep: 0,
    });
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const removeLevel = (id) => {
    const newAssignees = [...mainState.approvalSettings];

    newAssignees.splice(id, 1);
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleApprovalChange = (e, idx) => {
    const {
      target: { value },
    } = e;
    const data = JSON.parse(value);
    const newAssignees = [...mainState.approvalSettings];
    newAssignees[idx].staffId = data.staffId;
    newAssignees[idx].assigneeName = data.full_name;
    newAssignees[idx].roleId = data.emp_role;
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleSkipCheckChange = (e, idx) => {
    const {
      target: { checked },
    } = e;
    const newAssignees = [...mainState.approvalSettings];
    newAssignees[idx].isSkipStep = checked ? true : false;
    newAssignees[idx].skipStep = 0;
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleCheckChange = (e, idx) => {
    const {
      target: { value },
    } = e;
    const newAssignees = [...mainState.approvalSettings];
    newAssignees[idx].skipStep = value;
    setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleApproveDays = (event) => {
    setMainState({
      ...mainState,
      approveDays: event.target.checked ? 1 : 0,
    });
  };

  return (
    <>
      <div
        className="more-setting-form-container"
        style={{
          position: "relative",
          height: "auto",
          paddingBottom: "50px",
          backgroundColor: "transparent",
        }}
      >
        <Form className="form" onSubmit={handleSubmit}>
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Mandatory Approval required if request exceeds</label>
                <Form.Control
                  name="mandatoryApprovalRequest"
                  value={mainState.mandatoryApprovalRequest}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  placeholder="ex:5"
                  style={{ width: "80px" }}
                  className="universal-input-one"
                />
                <label>&nbsp;times in a&nbsp;</label>
                <Form.Select
                  name="mandatoryApprovalYears"
                  value={mainState.mandatoryApprovalYears}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "170px" }}
                  className="universal-input-one"
                >
                  <option value="">Select an option</option>
                  {attendOptions.map((row, idx) => {
                    return (
                      <option value={row.id} key={idx}>
                        {row.options}
                      </option>
                    );
                  })}
                </Form.Select>
              </Col>
            </Row>
            <Form.Control.Feedback type={"invalid"}>
              Field is required
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Row
              className="flex-form mb-5"
              style={{ backgroundColor: "transparent" }}
            >

              <Col sm="12" className="p-0">
                <label className="color-white mt-3">
                  Reporting Manager Level
                </label>
              </Col>
              <Col sm={12} className="p-0 mb-2 approval-con">
                <h4 className="color-white mt-2">Level 1</h4>
                <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                  <div>
                    <Form.Label className="color-white">
                      If Level 1 Manager does not respond within
                    </Form.Label>
                  </div>
                  <div>
                    <Form.Control
                      name="l1Days"
                      value={mainState.l1Days}
                      placeholder="ex:5"
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="universal-input-one"
                      style={{ width: "100px" }}
                    />
                  </div>
                  <div>
                    <Form.Label className="color-white">days</Form.Label>
                  </div>
                </Form.Group>

                <Form.Group className="d-flex align-items-center justify-content-start gap-2 mb-2">
                  <Form.Check
                    type="radio"
                    name="l1IsAutoPassApproval"
                    label="Auto Approval"
                    value={"1"}
                    checked={mainState.l1IsAutoPassApproval == "1"}
                    onChange={(e) => {
                      mainHandleChange(e);
                    }}
                    className="color-white"
                  />
                  <span
                    className="color-white"
                    style={{ position: "relative", top: "-3px" }}
                  >
                    OR
                  </span>
                  <Form.Check
                    type="radio"
                    name="l1IsAutoPassApproval"
                    label="Escalate  to level 2"
                    value={"2"}
                    checked={mainState.l1IsAutoPassApproval == "2"}
                    onChange={(e) => {
                      mainHandleChange(e);
                    }}
                    className="color-white"
                  />
                </Form.Group>
              </Col>

              {mainState.l1IsAutoPassApproval == "2" && (
                <Col
                  sm={12}
                  className="p-0 mb-3 approval-con"
                  style={{ borderTop: "1px solid gray" }}
                >
                  <h4 className="color-white mt-2 mb-">Level 2</h4>
                  <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                    <div>
                      <Form.Label className="color-white">
                        If Level 2 Manager does not respond within
                      </Form.Label>
                    </div>
                    <div>
                      <Form.Control
                        name="l2Days"
                        value={mainState.l2Days}
                        placeholder="ex:5"
                        onChange={(e) => {
                          mainHandleChange(e);
                        }}
                        className="universal-input-one"
                        style={{ width: "100px" }}
                      />
                    </div>
                    <div>
                      <Form.Label className="color-white">days</Form.Label>
                    </div>
                  </Form.Group>

                  <Form.Group className="d-flex align-items-center justify-content-start gap-2 mb-2">
                    <Form.Check
                      type="radio"
                      name="l2IsAutoPassApproval"
                      label="Auto Approval"
                      value={"1"}
                      checked={mainState.l2IsAutoPassApproval == "1"}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="color-white"
                    />
                    <span
                      className="color-white"
                      style={{ position: "relative", top: "-3px" }}
                    >
                      OR
                    </span>
                    <Form.Check
                      type="radio"
                      name="l2IsAutoPassApproval"
                      label="Escalate  to level 3"
                      value={"2"}
                      checked={mainState.l2IsAutoPassApproval == "2"}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="color-white"
                    />
                  </Form.Group>
                </Col>
              )}

              {mainState.l2IsAutoPassApproval == "2" && (
                <Col
                  sm={12}
                  className="p-0 mb-3 approval-con"
                  style={{ borderTop: "1px solid gray" }}
                >
                  <h4 className="color-white mt-2">Level 3</h4>
                  <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                    <div>
                      <Form.Label className="color-white">
                        If Level 3 Manager does not respond within
                      </Form.Label>
                    </div>
                    <div>
                      <Form.Control
                        name="l3Days"
                        value={mainState.l3Days}
                        placeholder="ex:5"
                        onChange={(e) => {
                          mainHandleChange(e);
                        }}
                        className="universal-input-one"
                        style={{ width: "100px" }}
                      />
                    </div>
                    <div>
                      <Form.Label className="color-white">days</Form.Label>
                    </div>
                  </Form.Group>

                  <Form.Group className="d-flex align-items-center justify-content-start gap-2">
                    <Form.Check
                      type="radio"
                      name="l3IsAutoPassApproval"
                      label="Auto Approval"
                      value={"1"}
                      checked={mainState.l3IsAutoPassApproval == "1"}
                      onChange={(e) => {
                        mainHandleChange(e);
                      }}
                      className="color-white"
                    />

                  </Form.Group>
                </Col>
              )}

            </Row>
          </Form.Group>

          <Row>
            <Col
              sm="12"
              style={{
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Back"}
                url_or_onclick={() => setUpdateValue("3")}
                icon={null}
                width="150px"
              />

              <CustomButton
                type={"button"}
                class_name="p_btn universal-input-one"
                text={"Next"}
                url_or_onclick={() => setUpdateValue("5")}
                icon={null}
                width="150px"
              />
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

const UpdateAutoHalfDay = ({
  mainHandleChange,
  setMainTabIndex,
  mainState,
  beforeSubmitSettingData,
  store,
  setUpdateValue,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    beforeSubmitSettingData();
    if (mainState.moduleName == "") {
      setMainTabIndex(0);
    }
  };
  return (
    <>
      <div
        className="more-setting-form-container"
        style={{ backgroundColor: "transparent" }}
      >
        <div className="form">
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Auto Half Day if Late by&nbsp;</label>
                <Form.Control
                  name="allowHalfDays"
                  value={mainState.allowHalfDays}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  placeholder="eg:120 mins"
                  style={{ width: "200px" }}
                  className="universal-input-one"
                />
                <label>&nbsp;&nbsp;Minutes&nbsp;&nbsp;</label>
              </Col>
            </Row>
            <Form.Control.Feedback type={"invalid"}>
              Field is required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Row>
              <Col sm={12} className="flex-form mb-3 universal-bg-color">
                <label>Allow upto &nbsp;</label>
                <Form.Control
                  name="allowHalfDaysYears"
                  value={mainState.allowHalfDaysYears}
                  onChange={(e) => {
                    mainHandleChange(e);
                  }}
                  style={{ width: "200px" }}
                  placeholder="Enter days"
                  className="universal-input-one"
                />
                <label>&nbsp;&nbsp;days&nbsp;&nbsp;</label>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group style={{ padding: "10px 0" }}>
            <Row>
              <Col
                sm="12"
                style={{
                  padding: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <CustomButton
                  type={"Button"}
                  class_name="p_btn universal-input-one"
                  text={"Back"}
                  url_or_onclick={() => setUpdateValue("4")}
                  icon={null}
                  width="150px"
                />
              </Col>
            </Row>
          </Form.Group>
        </div>
      </div>
    </>
  );
};
